import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Lock, LocationOn, Person } from "@mui/icons-material";
import { MdPersonAddAlt } from "react-icons/md";
// import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import AddIcon from "@mui/icons-material/Add";
import React, { useEffect, useState } from "react";
import "./stylepersonal.css";
import { FormGroup, FormControlLabel, Switch, div } from "@mui/material";
import Typography from "@mui/material/Typography";
import EditIcon from "@mui/icons-material/Edit";
import RoomIcon from "@mui/icons-material/Room";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import PublicIcon from "@mui/icons-material/Public";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import { useRef } from "react";
import { HiPaperClip } from "react-icons/hi";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { Plus } from "lucide-react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import InfoIcon from "@mui/icons-material/Info";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import dayjs from "dayjs";
import {
  AssignmentInd as PassportIcon,
  Event as EventIcon,
  LocationCity as PlaceIcon,
  Public as CountryIcon,
  InsertDriveFile as ImageIcon,
} from "@mui/icons-material";
import {
  AccountCircle,
  Badge,
  Wc,
  Height as HeightIcon,
  MonitorWeight,
  Language,
  VpnKey,
  AlternateEmail,
  Work,
  CheckCircle,
  CalendarToday,
  Favorite,
  GroupWork,
  Visibility,
  Accessibility,
  Home as HomeIcon,
  FlightTakeoff as FlightTakeoffIcon,
  LocationOn as LocationOnIcon,
  PhoneIphone as PhoneIphoneIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
} from "@mui/icons-material";

import WorkIcon from "@mui/icons-material/Work";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BadgeIcon from "@mui/icons-material/Badge";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import ApartmentIcon from "@mui/icons-material/Apartment";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CategoryIcon from "@mui/icons-material/Category";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

import {
  Card,
  CardContent,
  FormHelperText,
  InputAdornment,
  IconButton,
  FormLabel,
  Input,
} from "@mui/material";

import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import VisaIcon from "@mui/icons-material/AssignmentInd"; // Substitute for visa
import PersonIcon from "@mui/icons-material/Person";
import EngineeringIcon from "@mui/icons-material/Engineering";

import { IoIosPerson } from "react-icons/io";
import { GiOfficeChair } from "react-icons/gi";
import { MdContactEmergency } from "react-icons/md";
import { GoDotFill } from "react-icons/go";
import { MdAddChart } from "react-icons/md";
import axios from "axios";
import { MdFormatListBulletedAdd } from "react-icons/md";
import MasterJobTablePopUp from "./MasterJobTablePopUp";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getAllEmp } from "../../../features/Emp/EmpSlice";
import { TbEPassport } from "react-icons/tb";
import { MdMenuOpen } from "react-icons/md";
import { IoIosContact } from "react-icons/io";
import { IoDocumentsOutline } from "react-icons/io5";
import { IoAddCircleSharp } from "react-icons/io5";
import { GiThreeLeaves } from "react-icons/gi";
import { MdAddCircleOutline } from "react-icons/md";
import CreateAllowancePopup from "../ViewEmp/CreateAllowancePopup";
import CreateIncrementPopup from "../ViewEmp/CreateIncrementPopup";
import { Link } from "react-router-dom";
import CreateAllowance from "../CreateAllowance/CreateAllowance";
import CreateIncrement from "../CreateIncrement/CreateIncrement";
import SalaryPayablePopup from "./SalaryPayablePopup";
import { base_url } from "../../../utils/AxiosConfig";
import { Oval } from "react-loader-spinner";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import user1 from "../../../images/ic_no_person_photo.svg";
// import user1 from "../../../images/no-person-image.png";
import { BiSolidEditAlt } from "react-icons/bi";
import { Button } from "@mui/material";
import PaymentsIcon from "@mui/icons-material/Payments";
import { IoTime } from "react-icons/io5";
import { IoDocumentText } from "react-icons/io5";

import { format } from "date-fns";
import { base_url_image_post_api } from "../../../utils/ImageCreationAPI";
import ic_dropdown from "../../images/ic_dropdown.png";
import ic_pencil from "../../images/ic_pencil.png";
import ic_close_department from "../../images/ic_close_department.png";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
// import { format, parseISO } from 'date-fns';
import { FiX } from "react-icons/fi";

let Empschema = Yup.object().shape({
  CmpCode: Yup.string(),
  EmpId: Yup.string().required("Emp Id Required"),
  // EmpId: Yup.string(),
  AlternateID: Yup.string(),
  Status: Yup.string(),
  Title: Yup.string(),
  // FirstName: Yup.string().required("First Name Required"),
  FistName: Yup.string().required("First Name Required"),
  // FirstName: Yup.string(),
  MiddleName: Yup.string(),
  LastName: Yup.string().required("Last Name Required"),
  // LastName: Yup.string(),
  // DOB: Yup.string(),
  DOB: Yup.date(),
  MaritalStatus: Yup.string(),
  // Gender: Yup.string().required("Gender Required"),
  Gender: Yup.string(),
  // Nationality: Yup.string().required("Nationality Required"),
  Nationality: Yup.string(),
  // Nationality: Yup.string(),
  Height: Yup.string(),
  Weight: Yup.string(),
  // JoinDate: Yup.string().required("JoinDate Required"),
  JoinDate: Yup.date().required("JoinDate Required"),
  // JoinDate: Yup.string(),
  JobTitle: Yup.string(),
  JobType: Yup.string(),
  ShiftGroup: Yup.string(),
  Department: Yup.string(),
  Division: Yup.string(),
  Grade: Yup.string(),
  BankAccountNo: Yup.string(),
  BankName: Yup.string(),
  AgentID: Yup.string(),
  CurrentAddress: Yup.string(),
  HomeAddress: Yup.string(),
  HomeAirport: Yup.string(),
  WorkMobile: Yup.string(),
  PersonalMobile: Yup.string(),
  WorkPhone: Yup.string(),
  PersonalPhone: Yup.string(),
  WorkEmail: Yup.string(),
  PersonalEmail: Yup.string(),
  PassportNo: Yup.string(),
  PassportIssueDate: Yup.date(),
  PassportExpiryDate: Yup.date(),
  PassportPlaceofIssue: Yup.string(),
  PassportCountryofIssue: Yup.string(),
  PartTimeLabour: Yup.string(),
  PartTimeLabourExpiryDate: Yup.date(),
  EmiratesId: Yup.string(),
  EmiratesIdExpiryDate: Yup.date(),
  VisaNo: Yup.string(),
  VisaExpiryDate: Yup.date(),
  InsuranceNo: Yup.string(),
  InsuranceExpiryDate: Yup.date(),
  DrivingLicenceNo: Yup.string(),
  DrivingLicenceExpiryDate: Yup.date(),
  PersonId: Yup.string(),
  PersonIdExpiryDate: Yup.date(),
  BasicPay: Yup.number(),
  Allowances_OT: Yup.number(),
  Allowances_NOT: Yup.number(),
  NetSalary: Yup.number(),
  NormalHrs: Yup.number(),
  HourlyWage: Yup.number(),
  OTrate: Yup.number(),
  SplOtRate: Yup.number(),
  photo: Yup.string(),
  Active: Yup.string(),
  Memos: Yup.string(),
  Notes: Yup.string(),
  SalaryAc: Yup.string(),
  AdvanceAc: Yup.string(),
  password: Yup.string(),
  onlineallow: Yup.string(),
});

const PersonalInfo = () => {
  // dept
  const initialBranchInAction = {
    branch_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7374", // dummy transaction id
    mode: "ENTRY",
  };

  // division
  const initialDivisionInAction = {
    division_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7375", // dummy transaction id
    mode: "ENTRY",
  };

  // JobTitle
  const initialJobTitleInAction = {
    jobTitle_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7376", // dummy transaction id
    mode: "ENTRY",
  };

  // Grade
  const initialGradeInAction = {
    grade_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7374", // dummy transaction id
    mode: "ENTRY",
  };

  // Status
  const initialStatusInAction = {
    status_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7378", // dummy transaction id
    mode: "ENTRY",
  };

  // ShiftGroup
  const initialShiftGroupInAction = {
    shiftGroup_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7377", // dummy transaction id
    mode: "ENTRY",
  };

  // dept
  const [branchNameInInputBoxNew, setBranchNameInInputBoxNew] = useState(
    initialBranchInAction,
  );

  // division
  const [divisionNameInInputBoxNew, setDivisionNameInInputBoxNew] = useState(
    initialDivisionInAction,
  );

  // JobTitle
  const [jobTitleNameInInputBoxNew, setJobTitleNameInInputBoxNew] = useState(
    initialJobTitleInAction,
  );

  // Grade
  const [gradeNameInInputBoxNew, setGradeNameInInputBoxNew] =
    useState(initialGradeInAction);

  // Status
  const [statusNameInInputBoxNew, setStatusNameInInputBoxNew] = useState(
    initialStatusInAction,
  );
  // ShiftGroup
  const [shiftGroupNameInInputBoxNew, setShiftGroupNameInInputBoxNew] =
    useState(initialShiftGroupInAction);

  // dept
  const initialBranchInActionEdit = {
    branch_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  // division
  const initialDivisionInActionEdit = {
    division_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  // JobTitle
  const initialJobTitleInActionEdit = {
    jobTitle_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  // Status
  const initialStatusInActionEdit = {
    status_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  // grade
  const initialGradeInActionEdit = {
    grade_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  // shift group
  const initialShiftGroupInActionEdit = {
    shiftGroup_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  // dept
  const [branchNameInInputBoxEdit, setBranchNameInInputBoxEdit] = useState(
    initialBranchInActionEdit,
  );

  //grade
  const [gradeNameInInputBoxEdit, setGradeNameInInputBoxEdit] = useState(
    initialGradeInActionEdit,
  );

  // division
  const [divisionNameInInputBoxEdit, setDivisionNameInInputBoxEdit] = useState(
    initialDivisionInActionEdit,
  );

  // JobTitle
  const [jobTitleNameInInputBoxEdit, setJobTitleNameInInputBoxEdit] = useState(
    initialJobTitleInActionEdit,
  );

  // Status
  const [statusNameInInputBoxEdit, setStatusNameInInputBoxEdit] = useState(
    initialStatusInActionEdit,
  );

  // ShiftGroup
  const [shiftGroupNameInInputBoxEdit, setShiftGroupNameInInputBoxEdit] =
    useState(initialShiftGroupInActionEdit);

  // dept
  const [showDepartmentCreationEditPopup, setShowDepartmentCreationEditPopup] =
    useState(false);

  // grade
  const [showGradeCreationEditPopup, setShowGradeCreationEditPopup] =
    useState(false);

  // division
  const [showDivisionCreationEditPopup, setShowDivisionCreationEditPopup] =
    useState(false);

  // JobTitle
  const [showJobTitleCreationEditPopup, setShowJobTitleCreationEditPopup] =
    useState(false);

  // Status
  const [showStatusCreationEditPopup, setShowStatusCreationEditPopup] =
    useState(false);

  // ShiftGroup
  const [showShiftGroupCreationEditPopup, setShowShiftGroupCreationEditPopup] =
    useState(false);

  // dept
  const [departmentLisFromAPI, setDepartmentLisFromAPI] = useState(null);
  // division
  const [divisionListFromAPI, setDivisionListFromAPI] = useState(null);

  // grade
  const [gradeListFromAPI, setGradeListFromAPI] = useState(null);

  // shiftGroup
  const [shiftGroupListFromAPI, setShiftGroupListFromAPI] = useState(null);

  // jobTitleList
  const [jobTitleListFromAPI, setJobTitleListFromAPI] = useState(null);
  // status
  const [statusListFromAPI, setStatusListFromAPI] = useState(null);

  // let initialDOBDate = format(new Date(), "dd-MMM-yyyy");
  let initialDOBDate = format(new Date(), "yyyy-MM-dd");
  // let initialJoiningDate = format(new Date(), "dd-MM-yyyy");
  let initialJoiningDate = format(new Date(), "yyyy-MM-dd");

  let portNumberLocal = localStorage.getItem("BondTimeportNoData");

  let portNumber = JSON.parse(portNumberLocal)[0].PORTNO;

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [Category, setCategory] = useState(true);
  const [valuedata, setValuedata] = useState(null);
  const [EmpId, setEmpId] = useState(false);
  const [EmpIdTop, setEmpIdTop] = useState(null);
  const [DupCheck, setDupCheck] = useState(false);
  const [basicPay, setbasicPay] = useState();

  const [allowanceAmountSum, setAllowanceAmountSum] = useState(0);
  const [incrementAmountSum, setIncrementAmountSum] = useState(0);
  const [AllowanceData, setAllowanceData] = useState(null);
  const [IncrementData, setIncrementData] = useState(null);
  const [IncTotal, setIncTotal] = useState(null);
  const [AlvTotal, setAlvTotal] = useState(null);
  const [SalaryPayment, setSalaryPay] = useState();

  const [showSubmitLoader, setShowSubmitLoader] = useState(false);

  const empState = useSelector((state) => state?.emp?.emplist);
  const dispatch = useDispatch();

  const [userDataArray, setUserDataArray] = useState([]);

  const [loginUser, setLoginUser] = useState("");

  const [imagePath, setImagePath] = useState("");

  const [imageDescription, setImageDescription] = useState("EMPIMAGE");

  const [photo, setPhoto] = useState(null);

  const [photoFile, setPhototFile] = useState(null);

  const handlePhotoUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setPhoto(URL.createObjectURL(file)); // Create a preview URL
      setPhototFile(file);
      console.log("File uploaded:", file);
    } else {
      alert("Please upload a valid image file!");
    }
  };

  const getDefaultDateTime = () => {
    const now = new Date();
    now.setHours(8, 0, 0, 0);

    const pad = (n) => n.toString().padStart(2, "0");

    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
      now.getDate(),
    )}T${pad(now.getHours())}:${pad(now.getMinutes())}:00`;
  };

  const formatDateTimeSQL = (value) => {
    const date = new Date(value);

    const pad = (n) => n.toString().padStart(2, "0");

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate(),
    )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
      date.getSeconds(),
    )}`;
  };

  // console.log(Category);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      CmpCode: companyCode,
      mode: "ENTRY",
      EmpId: EmpIdTop || "",
      AlternateID: "",
      // Status: "Active",
      Status: "",
      Title: "",
      // FirstName: "",
      FistName: "",
      MiddleName: "",
      LastName: "",
      DOB: initialDOBDate,
      // DOB: null, /////////////////////null
      MaritalStatus: "",
      // MaritalStatus: null, ////////////////////null
      Gender: "",
      Nationality: "", ///////////////////////////capitalise
      Height: "",
      Weight: "",
      JoinDate: initialJoiningDate,
      // JoinDate: "",
      JobTitle: "",
      JobType: "",
      ShiftGroup: "",
      Department: "",
      Division: "",
      Grade: "",
      BankAccountNo: "", /////////////////////////////must be string
      BankName: "",
      AgentID: "",
      CurrentAddress: "",
      HomeAddress: "",
      HomeAirport: "",
      WorkMobile: "", /////////////////////////////must be string
      PersonalMobile: "", /////////////////////////////must be string
      WorkPhone: "", /////////////////////////////must be string
      PersonalPhone: "", /////////////////////////////must be string
      WorkEmail: "",
      PersonalEmail: "",
      PassportNo: "",
      PassportIssueDate: "",
      PassportExpiryDate: "",
      PassportPlaceofIssue: "",
      PassportCountryofIssue: "",
      EmiratesId: "",
      EmiratesIdExpiryDate: "",
      VisaNo: "",
      VisaExpiryDate: "",
      InsuranceNo: "",
      InsuranceExpiryDate: "",
      DrivingLicenceNo: "",
      DrivingLicenceExpiryDate: "",
      PersonId: "",
      PersonIdExpiryDate: "",
      BasicPay: basicPay || 0,
      Allowances_OT: AlvTotal || 0,
      Allowances_NOT: IncTotal || 0,
      NetSalary: basicPay + AlvTotal + IncTotal || 0,
      NormalHrs: 0,
      HourlyWage: 0, /////////////////////////////must be number
      OTrate: 0, /////////////////////////////must be number
      SplOtRate: 0, /////////////////////////////must be number
      photo: photo ? photo : "",
      // photo: null, /////////////////////////////must be null
      Active: "Yes",
      // Memos: null, /////////////////////////////must be null
      Memos: "", /////////////////////////////must be null
      Notes: "",
      SalaryAc: SalaryPayment || "", /////////////////////////////must be null
      AdvanceAc: "",
      password: "",
      onlineallow: "T",
      // Lattitude: "",
      Latitude: "",
      // longitude: "",
      longitude: "",
      PartTimeLabour: "",
      PartTimeLabourExpiryDate: "",
      regularTime: getDefaultDateTime(),
    },

    // must not be null
    // MaritalStatus
    // DOB
    // Memos:
    // SalaryAc
    validationSchema: Empschema,

    onSubmit: async (values) => {
      setValuedata([values]);
      console.log("onSubmit:", values);

      try {
        const response = await axios.get(
          `${base_url}/api/DupCheck/${companyCode}/EMPCODE/${
            values.EmpId || null
          }`,
        );
        console.log("response.data from duplicate check:", response.data);
        const countValue = response.data[0].COUNT;
        console.log("DupCheck count:", countValue);
        // postEmpData();
        console.log("calling postEmpData();");
        if (countValue === 1) {
          toast.error("EmpId Exist, Try With New Id");
        } else {
          await postEmpData();
        }
      } catch (error) {
        console.error("DupCheckError:", error);
        toast.error("Error checking duplicate EmpId");
      }
    },
  });

  // useEffect(() => {
  //   if (valuedata && DupCheck) {
  //     console.log("inside postEmpData");
  //     postEmpData();
  //   }
  // }, [valuedata, DupCheck]);

  const dupeCheckApi = async (empId) => {
    await axios
      .get(`${base_url}/api/DupCheck/${companyCode}/EMPCODE/${empId}`)
      .then((response) => {
        const countValue = response.data[0].COUNT;
        console.log(countValue);
        if (countValue === 1) {
          console.log("Employee Id Already Exist");
          toast.error("EmpId Exist Try With New Id");
        }
        if (countValue === 0) {
          setEmpId(true);
          setDupCheck(true);
        }
      })
      .catch((error) => {
        console.error("DupCheckError:", error);
      });
  };

  useEffect(() => {
    if (EmpIdTop) {
      dupeCheckApi(EmpIdTop);
    }
  }, [EmpIdTop]);

  // Show toast if there are validation errors
  // const handleFormSubmit = (event) => {
  //   setShowSubmitLoader(true)
  //   event.preventDefault();

  //   formik.handleSubmit();

  //   setTimeout(() => {
  //     if (formik.errors) {
  //       setShowSubmitLoader(false)
  //       console.log(formik.errors)
  //       toast.error('Please correct the errors in the form.', {
  //         position: toast.POSITION.TOP_RIGHT,
  //       });

  //     }
  //   }, 0);
  // };

  const handleFormSubmit = async (event) => {
    console.log("handleFormSubmit clicked 1", event.target.value);
    event.preventDefault();
    setShowSubmitLoader(true);

    // formik.handleSubmit();

    // Manually trigger form validation and get the errors
    const errors = await formik.validateForm();

    console.log("formikerrors:", errors);

    setTimeout(() => {
      if (Object.keys(errors).length > 0) {
        setShowSubmitLoader(false);
        toast.error("Please correct the errors in the form.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        formik.handleSubmit();
      } else {
        // No errors, proceed with form submission
        formik.handleSubmit();
      }
    }, 0);
  };
  const [isSubmitted, setIsSubmitted] = useState(false);
  const postEmpData = async () => {
    setShowSubmitLoader(true);
    console.log("valuedata", valuedata);

    try {
      const sanitizeDate = (dateStr) =>
        dateStr === "1900-01-01T00:00:00" ? "" : dateStr;

      const payload = [
        {
          ...formik.values,
          CmpCode: formik.values.CmpCode?.toUpperCase(), // optional

          DOB: sanitizeDate(formik.values.DOB),
          DrivingLicenceExpiryDate: sanitizeDate(
            formik.values.DrivingLicenceExpiryDate,
          ),
          EmiratesIdExpiryDate: sanitizeDate(
            formik.values.EmiratesIdExpiryDate,
          ),
          InsuranceExpiryDate: sanitizeDate(formik.values.InsuranceExpiryDate),
          PassportExpiryDate: sanitizeDate(formik.values.PassportExpiryDate),
          PassportIssueDate: sanitizeDate(formik.values.PassportIssueDate),
          PersonIdExpiryDate: sanitizeDate(formik.values.PersonIdExpiryDate),
          VisaExpiryDate: sanitizeDate(formik.values.VisaExpiryDate),
          regularTime: formatDateTimeSQL(formik.values.regularTime),
        },
      ];
      // const EmpRes = await axios.post(`${base_url}/api/PersonalInfoReg/`, valuedata);
      // console.log("Submitting to PersonalInfoReg:", [formik.values]);
      console.log("Submitting to PersonalInfoReg:", payload);
      const EmpRes = await axios.post(
        `${base_url}/api/PersonalInfoReg/`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (EmpRes.data.result === "Saved") {
        toast.success("Emp Registered Successfully");
        setIsSubmitted(true);
        setEmpIdTop(null);
        setDupCheck(false);
        setShowSubmitLoader(false);
        // setValuedata(null);
        // formik.resetForm(); // Reset form after success
      } else {
        toast.error("Something went wrong");
        setShowSubmitLoader(false);
      }

      if (photoFile) {
        await sendUserImage();
      }
    } catch (error) {
      toast.error("An error occurred while submitting the form");
      setShowSubmitLoader(false);
      setDupCheck(false);
      console.error("Submission error:", error);
    }
  };

  // useEffect(() => {
  //   const postEmpData = async () => {
  //     setShowSubmitLoader(true)
  //     console.log(valuedata);
  //     try {
  //       const EmpRes = await axios.post(`${base_url}api/PersonalInfoReg/`, valuedata);

  //       if (EmpRes.data.result === "Saved") {
  //         toast.success("Emp Registered Successfully");
  //         setEmpIdTop(null);
  //         setDupCheck(false);
  //         setShowSubmitLoader(false);
  //       } else {
  //         toast.error("Something went wrong");
  //         setShowSubmitLoader(false);
  //       }
  //     } catch (error) {
  //       toast.error("An error occurred while submitting the form");
  //       setShowSubmitLoader(false);
  //       setDupCheck(false);
  //       console.error("Submission error:", error);
  //     }
  //   };
  //   if (DupCheck === true) {
  //     postEmpData();

  //     if (photo) {
  //       sendUserImage()
  //     }
  //   }
  // }, [DupCheck]);

  const handleButtonClick = (e) => {
    e.preventDefault();
  };

  const calculationInc = (Incsum) => {
    // the callback. Use a better name
    console.log(Incsum);
    setIncTotal(Incsum);
  };
  const calculationAlv = (Alvsum) => {
    // the callback. Use a better name
    console.log("TotalcalculationAllowances:", Alvsum);
    setAlvTotal(Alvsum);
  };

  const SalaryPayable = (SalaryPay) => {
    // the callback. Use a better name
    console.log(SalaryPay);
    setSalaryPay(SalaryPay);
  };

  function handleAddrTypeChange(e) {
    setCategory(e.target.value);
    console.log(Category);
  }

  const getData = async () => {
    dispatch(getAllEmp());
  };

  useEffect(() => {
    getData();
  }, []);

  const fetchImagePath = async () => {
    try {
      console.log("calling ImgPath");
      console.log(
        `fetchImagePath-->${base_url}/api/MasterCount/${companyCode}/IMAGEPATH/${loginUser}/EMPIMAGE`,
      );

      const response = await axios.get(
        `${base_url}/api/MasterCount/${companyCode}/IMAGEPATH/${loginUser}/EMPIMAGE`,
      );

      console.log("response for imagepath fetch:", response);

      if (response.status === 200) {
        setImagePath(response.data);
      }
    } catch (error) {
      console.log("fetchImagePathErr", error);
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const sendUserImage = async () => {
    if (!photo && !photoFile) {
      toast.warn("no picture selected");
      return;
    }

    if (!EmpIdTop) {
      toast.warn("EmpId Required");
      return;
    }

    if (
      // !formik.values.FirstName ||
      !formik.values.FistName ||
      !formik.values.Nationality ||
      !formik.values.Gender ||
      !formik.values.LastName
    ) {
      toast.warn("All Required Fields Needed");
      return;
    }

    try {
      // Create a FormData instance
      const formData = new FormData();
      let resultOfBAse64Conversion = await toBase64(photoFile);

      formData.append("DOC_CODE", formik.values.EmpId);
      formData.append("DOC_TYPE", "DOCIMAGE");
      formData.append("file", photoFile);
      formData.append("cmpcode", companyCode);
      // formData.append("IMGBASE64", "XX");
      formData.append("IMGBASE64", resultOfBAse64Conversion);
      // formData.append("IMAGEPATH", imagePath[0]?.imagepath);
      // PostEmpImagePath
      let postEmpImagePath = localStorage.getItem("PostEmpImagePath");
      console.log("postEmpImagePath:", postEmpImagePath);
      console.log("postEmpImagePath:", `${postEmpImagePath}BONDTIME_EMP_IMG\\`);

      // Step 1: Clean up postEmpImagePath by removing extra quotes and trimming spaces
      let basePath = postEmpImagePath.replace(/['"]+/g, "").trim();

      // Step 2: Ensure it ends with a single backslash
      if (!basePath.endsWith("\\")) {
        basePath += "\\";
      }

      // Step 3: Append subfolder
      // const fullPath = `c:\\fileupload_common\\BONDTIME_EMP_IMG\\`;
      const fullPath = `${basePath}BONDTIME_EMP_IMG\\`;

      // Step 4: Add to formData
      formData.append("IMAGEPATH", fullPath);

      // Debug
      console.log("fullPath:", fullPath);

      // Axios configuration
      const config = {
        headers: {
          "Content-Type": "multipart/form-data", // Ensure the correct content type
        },
      };

      console.log("formData", formData);

      // Send the POST request
      const response = await axios.post(
        // `${base_url_image_post_api}/Posts`,
        `${base_url_image_post_api}/api/Image/upload`,
        formData,
        config,
      );

      // Handle response
      console.log("Response:", response.data);

      if (response.status === 200) {
        toast.success("Image uploaded successfully");
        setImageDescription("");
        setPhoto("");
        setPhototFile("");
      }
      // return response.data;
    } catch (error) {
      // Handle error
      console.error("Error uploading data:", error.response || error.message);
      toast.error("Some error occured");
      // throw error;
    }
  };

  const fetchData = async () => {
    try {
      const storedUserDataArray = localStorage.getItem("BondTimeLoginUserData");
      const parsedUserDataArray = JSON.parse(storedUserDataArray) || [];

      setUserDataArray(parsedUserDataArray);

      setLoginUser(
        parsedUserDataArray && parsedUserDataArray[0].salesman_name.trim(),
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getDepartmentList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPARTMENT/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setDepartmentLisFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  const getDivisionList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DIVISION/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setDivisionListFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  const getGradeList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/GRADE/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setGradeListFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  const getShiftGroupList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/SHIFTGROUP/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setShiftGroupListFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  const getJobTitleList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/JOBTITLE/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setJobTitleListFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  const getStatusList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/STATUS/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setStatusListFromAPI(newArray);
    } else {
      console.log("error");
    }
  };

  const getAllowanceList = async (EmpIdTop) => {
    // console.log("getAllowanceList called:",AlvTotal);
    const response = await axios.get(
      // `${base_url}/api/MASTERLIST/${companyCode}/PersonalInfoAllowanceReg/-`,
      `${base_url}/api/PersonalInfoAllowanceList/${companyCode}/${EmpIdTop}`,
    );
    // console.log("getAllowanceList response?.data:", response?.data);
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      // console.log("getAllowanceList newArray:", newArray);
      let allowancesSum = newArray?.reduce((a, v) => (a = a + v.Amount), 0);
      // console.log("getAllowanceList newArray: allowancesSum", AllowancesSum);

      setAllowanceData(newArray);
      setAllowanceAmountSum(allowancesSum);
    } else {
      console.log("error");
    }
  };

  const getIncrementList = async (EmpIdTop) => {
    console.log("getIncrementList called:");
    const response = await axios.get(
      `${base_url}/api/PersonalInfoIncrementList/${companyCode}/${EmpIdTop}`,
    );
    console.log("getIncrementList response?.data:", response?.data);
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );
      let incrementSum = newArray?.reduce((a, v) => (a = a + v.Amount), 0);
      setIncrementData(newArray);
      setIncrementAmountSum(incrementSum);
    } else {
      console.log("error");
    }
  };

  useEffect(() => {
    fetchData();
    getDepartmentList();
    getDivisionList();
    getJobTitleList();
    getStatusList();
    getGradeList();
    getShiftGroupList();
  }, []);

  useEffect(() => {
    if (formik.values.EmpId) {
      getAllowanceList(formik.values.EmpId);
      getIncrementList(formik.values.EmpId);
      console.log("emp id typed:");
    }
  }, [formik.values.EmpId]);

  useEffect(() => {
    if (loginUser && companyCode && portNumber) {
      fetchImagePath();
    }
  }, [loginUser, companyCode, portNumber]);

  // console.log('userDataArray', userDataArray)

  // console.log("loginUser", loginUser);

  // console.log("imagePath", imagePath);

  // console.log('photo', photo)

  const clickedOnOfficeCheckin = (valueFromClick) => {
    formik.setFieldValue("onlineallow", valueFromClick);
  };

  const clickedOnDepartment = (valueFromClick) => {
    formik.setFieldValue("Department", valueFromClick);
  };

  useEffect(() => {
    console.log("branchNameInInputBoxEdit54", branchNameInInputBoxEdit);
  }, [branchNameInInputBoxEdit]);

  // dept
  const newDepartmentAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/DEPARTMENT/${branchNameInInputBoxNew.branch_name}/${initialBranchInAction.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDepartmentList();
        setBranchNameInInputBoxNew(initialBranchInAction);
      }, {})
      .catch((err) => {});
  };

  // division
  const newDivisionAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/DIVISION/${divisionNameInInputBoxNew.division_name}/${initialDivisionInAction.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDivisionList();
        setDivisionNameInInputBoxNew(initialDivisionInAction);
      }, {})
      .catch((err) => {});
  };

  // grade
  const newGradeAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/GRADE/${gradeNameInInputBoxNew.branch_name}/ED54A276-A746-4649-B085-43CBBAEB7374`;

    axios
      .post(apiUrl)
      .then((res) => {
        getGradeList();
        setGradeNameInInputBoxNew(initialGradeInAction);
      }, {})
      .catch((err) => {});
  };

  // JobTitle
  const newJobTitleAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/JOBTITLE/${jobTitleNameInInputBoxNew.jobTitle_name}/${initialJobTitleInAction.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getJobTitleList();
        setJobTitleNameInInputBoxNew(initialJobTitleInAction);
      }, {})
      .catch((err) => {});
  };
  // Status
  const newStatusAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/STATUS/${statusNameInInputBoxNew.status_name}/${initialStatusInAction.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getStatusList();
        setStatusNameInInputBoxNew(initialStatusInAction);
      }, {})
      .catch((err) => {});
  };

  //ShiftGroup
  const newShiftGroupAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/SHIFTGROUP/${shiftGroupNameInInputBoxNew.shiftGroup_name}/${initialShiftGroupInAction.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getShiftGroupList();
        setShiftGroupNameInInputBoxNew(initialShiftGroupInAction);
      }, {})
      .catch((err) => {});
  };

  // dept

  const editDepartmentAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/DEPARTMENT/${branchNameInInputBoxEdit.branch_name}/${branchNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDepartmentList();
        setBranchNameInInputBoxEdit(initialBranchInActionEdit);
      }, {})
      .catch((err) => {});
  };

  // division
  const editDivisionAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/DIVISION/${divisionNameInInputBoxEdit.division_name}/${divisionNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDivisionList();
        setDivisionNameInInputBoxEdit(initialDivisionInActionEdit);
      }, {})
      .catch((err) => {});
  };

  // JobTitle
  const editJobTitleAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/JOBTITLE/${jobTitleNameInInputBoxEdit.jobTitle_name}/${jobTitleNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getJobTitleList();
        setJobTitleNameInInputBoxEdit(initialJobTitleInActionEdit);
      }, {})
      .catch((err) => {});
  };

  // Status
  const editStatusAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/STATUS/${statusNameInInputBoxEdit.status_name}/${statusNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getStatusList();
        setStatusNameInInputBoxEdit(initialStatusInActionEdit);
      }, {})
      .catch((err) => {});
  };

  // delete grade
  const deleteGradeAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/DELETE/${companyCode}/GRADE/${gradeNameInInputBoxEdit.branch_name}/${gradeNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getGradeList();
        setGradeNameInInputBoxEdit(initialGradeInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const [form, setForm] = React.useState({
    empId: "",
    title: "",
    gender: "",
    password: "",
    firstName: "",
    middleName: "",
    lastName: "",
    nationality: "",
    alternateId: "",
    height: "",
    weight: "",
    shiftGroup: "",
    division: "",
    maritalStatus: "",
    agentId: "",
    branch: "",
    jobTitle: "",
    officeCheckinMandatory: false,
    bankName: "",
    jobType: "",
    latitude: "",
    longitude: "",
    bankAccountNo: "",
    // dob: "",
    DOB: "",
    joinDate: "",
    active: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [isEditing, setIsEditing] = useState(false);

  const calculateAge = (dob) => {
    if (!dob) return "";
    const birthDate = dayjs(dob);
    const today = dayjs();
    return today.diff(birthDate, "year");
  };
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (EmpIdTop) {
      LeaveHistory(EmpIdTop);
      LeaveStatus(EmpIdTop);
    }
  }, [EmpIdTop]);

  const [leaveHistoryData, setLeaveHistoryData] = useState();
  const [leaveStatusData, setLeaveStatusData] = useState();

  const LeaveHistory = async (getEmpid) => {
    try {
      const response = await axios.get(
        // `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/LEAVEHISTORY/${getEmpid}/1900-01-01/1900-01-01/-`,
        // }/${FromDate}/${ToDate}/-`
        `${base_url}/api/CpaysCount/${companyCode}/LEAVE_HISTORY/${getEmpid}/-`,
      );
      if (response?.data) {
        console.log("response.data leave history", response.data);
        setLeaveHistoryData(response.data);
      } else {
        console.log("error");
      }
    } catch (err) {
      console.error("Error while fetchinh leave history:", err);
    }
  };

  const LeaveStatus = async (getEmpid) => {
    const response = await axios.get(
      // `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/LEAVESTATUS/${getEmpid}/1900-01-01/1900-01-01/-`,
      // `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/LEAVESTATUS/${PopUpData?.EmpId?PopUpData?.EmpId:null}/${FromDate}/${ToDate}/-`
      `${base_url}/api/CpaysCount/${companyCode}/LEAVE_STATUS/${getEmpid}/-`,
    );
    if (response?.data) {
      setLeaveStatusData(response.data);
      console.log("leave status:", response.data);
    } else {
      console.log("error");
    }
  };

  const editGradeAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/GRADE/${gradeNameInInputBoxEdit.branch_name}/${gradeNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getGradeList();
        setGradeNameInInputBoxEdit(initialGradeInActionEdit);
      }, {})
      .catch((err) => {});
  };

  useEffect(() => {
    console.log("formik:", formik);
  }, [formik]);

  console.log("DOB:", formik.values.DOB);
  console.log("JoinDate:", formik.values.JoinDate);
  console.log("DupCheck", DupCheck);
  console.log("Sending Regular Time:", formik.values.regularTime);

  return (
    <form onSubmit={handleFormSubmit} className="space-y-6">
      {/* {isSubmitted && (
        <p className="text-green-600">Form submitted successfully!</p>
      )} */}
      {/* <div>
        <h6 className="mb-4 text-2xl font-bold text-gray-600 flex  justify-start items-center">

          <span>Employee Registration</span>
        </h6>
      </div> */}
      <div className="">
        <div className="flex justify-left items-center">
          <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
          <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4 ">
            {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#2663EB] to-blue-700 text-white shadow-lg">
      <MdPersonAddAlt className="w-7 h-7" />
      </span> */}
            <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
              EMPLOYEE REGISTRATION
            </span>
          </h6>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mr-4 min-h-screen">
        {/* Left Column - Personal + Address Info */}
        <div className="lg:col-span-2 space-y-4 ">
          <div className="flex items-center bg-white rounded-md shadow-sm px-2 py-3 gap-6">
            {/* Photo Preview */}
            <div className="w-16 h-16 rounded-full overflow-hidden border border-gray-300 shadow-sm">
              <img
                src={photo || user1}
                alt="Preview"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Upload Input */}
            <div>
              <label
                htmlFor="PhotoUpload"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Upload Photo
              </label>
              <input
                id="PhotoUpload"
                type="file"
                accept="image/*"
                onChange={handlePhotoUpload}
                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 
              file:rounded-md file:border-0 file:text-sm file:font-semibold 
              file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 
                   cursor-pointer"
              />
            </div>

            {/* Submit Button */}
            <button
              type="button"
              onClick={sendUserImage}
              className="ml-auto inline-flex items-center px-4 py-2 rounded-md bg-blue-600 text-white 
            text-sm font-medium shadow-sm hover:bg-blue-700 transition"
            >
              Submit Photo
            </button>
          </div>
          {/* </div> */}

          {/* Personal Information */}
          <Card className="rounded-2xl shadow-md p-2">
            <CardContent>
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-md font-semibold text-[#2663EB] flex items-center gap-2">
                  <Badge className="text-[#2663EB] mb-1" /> PERSONAL INFORMATION
                </h2>
              </div>
              <div className="mb-6 flex items-center justify-between">
                <div className="flex justify-between items-center gap-6">
                  {/* <TextField
                    label="Employee ID"
                    name="empId"
                    value={formik.values.EmpId}
                    onChange={(e) => setEmpIdTop(e.target.value)}
                    variant="outlined"
                    // fullWidth
                    InputProps={{
                      startAdornment: <Work className="text-[#757575] mr-2" />,
                    }}
                    error={formik.touched.EmpId && Boolean(formik.errors.EmpId)}
                    helperText={formik.touched.EmpId && formik.errors.EmpId}
                  /> */}
                  <TextField
                    label="Employee ID"
                    name="EmpId"
                    // fullWidth
                    value={formik.values.EmpId}
                    onChange={(e) => {
                      formik.handleChange(e);
                      setEmpIdTop(e.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    variant="outlined"
                    InputProps={{
                      startAdornment: <Work className="text-[#757575] mr-2" />,
                    }}
                    error={formik.touched.EmpId && Boolean(formik.errors.EmpId)}
                    helperText={formik.touched.EmpId && formik.errors.EmpId}
                  />

                  {/* Password */}
                  <TextField
                    // type="password"
                    label="App Password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    variant="outlined"
                    // fullWidth
                    InputProps={{
                      startAdornment: (
                        <VpnKey className="text-[#757575] mr-2" />
                      ),
                    }}
                  />
                  {/* Active */}
                  <FormControl
                    // fullWidth
                    variant="outlined"
                    error={
                      formik.touched.Active && Boolean(formik.errors.Active)
                    }
                  >
                    <InputLabel id="active-label">Active</InputLabel>
                    <Select
                      labelId="active-label"
                      id="Active"
                      name="Active"
                      value={formik.values.Active}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      startAdornment={
                        <CheckCircle className="mr-2 text-[#757575]" />
                      }
                      label="Active"
                    >
                      <MenuItem>
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                    {formik.touched.Active && formik.errors.Active && (
                      <p className="text-red-500 text-sm mt-1">
                        {formik.errors.Active}
                      </p>
                    )}
                  </FormControl>
                </div>

                <div className="flex justify-between items-center gap-2 w-[28%]">
                  <FormControl
                    fullWidth
                    variant="outlined"
                    error={
                      formik.touched.Status && Boolean(formik.errors.Status)
                    }
                  >
                    <InputLabel id="department-label">Status</InputLabel>
                    <Select
                      labelId="status-label"
                      name="Status"
                      value={formik.values.Status}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      startAdornment={
                        <InfoIcon className="mr-2 text-gray-500" />
                      }
                      label="Status"
                    >
                      <MenuItem>
                        <em>Select Status</em>
                      </MenuItem>
                      {statusListFromAPI?.map((item, index) => (
                        <MenuItem key={index} value={item.Description}>
                          {item.Description}
                        </MenuItem>
                      ))}
                    </Select>
                    {/* {formik.touched.Status && (
                      <FormHelperText>
                        {formik.errors.Status}
                      </FormHelperText>
                    )} */}
                  </FormControl>

                  <button
                    type="button"
                    onClick={() => setShowStatusCreationEditPopup(true)}
                    className="bg-blue-500 hover:bg-blue-700 px-2 py-1 text-white font-semibold rounded-md"
                  >
                    Manage
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-4 gap-6 text-sm text-gray-700">
                {/* First Name */}
                <TextField
                  label="First Name"
                  // name="FirstName"
                  name="FistName"
                  value={formik.values.FistName}
                  onChange={formik.handleChange("FistName")}
                  onBlur={formik.handleBlur("FistName")}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <AccountCircle className="text-[#757575] mr-2" />
                    ),
                  }}
                  error={
                    formik.touched.FistName && Boolean(formik.errors.FistName)
                  }
                  helperText={formik.touched.FistName && formik.errors.FistName}
                />

                {/* Middle Name */}
                <TextField
                  label="Middle Name"
                  name="MiddleName"
                  value={formik.values.MiddleName}
                  onChange={formik.handleChange("MiddleName")}
                  onBlur={formik.handleBlur("MiddleName")}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <AccountCircle className="text-[#757575] mr-2" />
                    ),
                  }}
                />

                {/* Last Name */}
                <TextField
                  label="Last Name"
                  name="LastName"
                  value={formik.values.LastName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <AccountCircle className="text-[#757575] mr-2" />
                    ),
                  }}
                  error={
                    formik.touched.LastName && Boolean(formik.errors.LastName)
                  }
                  helperText={formik.touched.LastName && formik.errors.LastName}
                />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-sm text-gray-700">
                {/* Title */}
                {/* Title - Reduced Width */}
                <FormControl
                  variant="outlined"
                  sx={{ minWidth: 50, width: "100%" }}
                >
                  <InputLabel id="title-label">Title</InputLabel>
                  <Select
                    labelId="title-label"
                    name="Title"
                    className="w-full"
                    sx={{ "& .MuiSelect-select": { paddingLeft: "36px" } }}
                    value={formik.values.Title}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    startAdornment={
                      <Badge className="absolute left-2 text-[#757575]" />
                    }
                    label="Title"
                  >
                    <MenuItem>
                      <em>Title</em>
                    </MenuItem>
                    {/* <MenuItem value="1">Mr</MenuItem>
                    <MenuItem value="2">Sri</MenuItem> */}
                    <MenuItem value="Mr">Mr</MenuItem>
                    <MenuItem value="Ms">Ms</MenuItem>
                    <MenuItem value="Mrs">Mrs</MenuItem>
                  </Select>
                </FormControl>

                {/* AlternateID */}
                <TextField
                  label="Alternate ID"
                  name="AlternateID"
                  value={formik.values.AlternateID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <AlternateEmail className="text-[#757575] mr-2" />
                    ),
                  }}
                />

                {/* Employee ID */}

                {/* Gender */}
                <FormControl
                  fullWidth
                  variant="outlined"
                  error={formik.touched.Gender && Boolean(formik.errors.Gender)}
                >
                  <InputLabel id="gender-label">Gender</InputLabel>
                  <Select
                    labelId="gender-label"
                    name="Gender"
                    value={formik.values.Gender}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    startAdornment={<Wc className="mr-2 text-[#757575]" />}
                    label="Gender"
                  >
                    <MenuItem>
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                  </Select>
                  {formik.touched.Gender && (
                    <FormHelperText>{formik.errors.Gender}</FormHelperText>
                  )}
                </FormControl>
                {/* Nationality */}
                <TextField
                  label="Nationality"
                  name="Nationality"
                  value={formik.values.Nationality}
                  // onChange={formik.handleChange}
                  onChange={(e) => {
                    let value = e.target.value;

                    // Capitalize first letter
                    if (value.length > 0) {
                      value =
                        value.charAt(0).toUpperCase() +
                        value.slice(1).toLowerCase();
                    }

                    formik.setFieldValue("Nationality", value);
                  }}
                  onBlur={formik.handleBlur}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <Language className="text-[#757575] mr-2" />
                    ),
                  }}
                  error={
                    formik.touched.Nationality &&
                    Boolean(formik.errors.Nationality)
                  }
                  helperText={
                    formik.touched.Nationality && formik.errors.Nationality
                  }
                />
                {/* Height */}
                <TextField
                  label="Height"
                  name="Height"
                  value={formik.values.Height}
                  onChange={formik.handleChange("Height")}
                  onBlur={formik.handleBlur("Height")}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <HeightIcon className="text-[#757575] mr-2" />
                    ),
                  }}
                />
                {/* Weight */}
                <TextField
                  label="Weight"
                  name="Weight"
                  // type="number"
                  type="text"
                  value={formik.values.Weight}
                  onChange={formik.handleChange("Weight")}
                  onBlur={formik.handleBlur("Weight")}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <MonitorWeight className="text-[#757575] mr-2" />
                    ),
                  }}
                />
                {/* Marital Status */}
                {/* <TextField
                  label="Marital Status"
                  name="MaritalStatus"
                  value={formik.values.MaritalStatus}
                  onChange={formik.handleChange("MaritalStatus")}
                  onBlur={formik.handleBlur("MaritalStatus")}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <Favorite className="text-[#757575] mr-2" />
                    ),
                  }}
                /> */}

                <FormControl fullWidth variant="outlined">
                  <InputLabel shrink>Marital Status</InputLabel>
                  <Select
                    name="MaritalStatus"
                    value={formik.values.MaritalStatus}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    startAdornment={<Wc className="mr-2 text-[#757575]" />}
                    displayEmpty
                    label="Marital Status"
                  >
                    <MenuItem disabled>Select Marital Status</MenuItem>
                    <MenuItem value="Single">Single</MenuItem>
                    <MenuItem value="Married">Married</MenuItem>
                    <MenuItem value="Divorced">Divorced</MenuItem>
                    <MenuItem value="Widowed">Widowed</MenuItem>
                  </Select>
                </FormControl>

                <div className="flex justify-between items-center gap-2">
                  {/* Department (Branch) replaced to department , menu list data from API */}
                  <FormControl
                    fullWidth
                    variant="outlined"
                    error={
                      formik.touched.Department &&
                      Boolean(formik.errors.Department)
                    }
                  >
                    {/* <InputLabel id="department-label">Branch</InputLabel> */}
                    <InputLabel id="department-label">Department</InputLabel>
                    <Select
                      labelId="department-label"
                      name="Department"
                      value={formik.values.Department}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      startAdornment={
                        <ApartmentIcon className="mr-2 text-gray-500" />
                      }
                      label="Department"
                    >
                      <MenuItem>
                        <em>Select Department</em>
                      </MenuItem>
                      {departmentLisFromAPI?.map((item, index) => (
                        <MenuItem key={index} value={item.Description}>
                          {item.Description}
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.touched.Department && (
                      <FormHelperText>
                        {formik.errors.Department}
                      </FormHelperText>
                    )}
                  </FormControl>

                  <button
                    type="button"
                    onClick={() => setShowDepartmentCreationEditPopup(true)}
                    className="bg-blue-500 hover:bg-blue-700 px-2 py-1 text-white font-semibold rounded-md"
                  >
                    Manage
                  </button>
                </div>

                {/* Date of Birth */}
                {/* // Inside your component */}
                <TextField
                  label="Date of Birth"
                  id="DOB"
                  type="date"
                  name="DOB"
                  // value={form.dob}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.DOB}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />

                <TextField
                  label="Join Date"
                  id="JoinDate"
                  type="date"
                  name="JoinDate"
                  // onFocus={(e) => (e.target.type = "date")}
                  // onChange={formik.handleChange("JoinDate")}
                  // onBlur={formik.handleBlur("JoinDate")}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.JoinDate}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  error={
                    formik.touched.JoinDate && Boolean(formik.errors.JoinDate)
                  }
                  helperText={formik.touched.JoinDate && formik.errors.JoinDate}
                />
                {/* Office Check-in Mandatory */}
                <FormControlLabel
                  control={
                    <Switch
                      checked={formik.values.onlineallow === "T"}
                      onChange={(e) =>
                        formik.setFieldValue(
                          "onlineallow",
                          e.target.checked ? "T" : "",
                        )
                      }
                      name="onlineallow"
                      color="primary"
                    />
                  }
                  label="Office Check-in Mandatory"
                />
                {formik.touched.onlineallow && formik.errors.onlineallow && (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.onlineallow}
                  </div>
                )}
              </div>
            </CardContent>
          </Card>

          {/* Address Information */}
          <Card className="shadow-md p-2">
            <CardContent className="relative">
              <div className="absolute top-4 right-4">
                {/* <IconButton onClick={() => setIsEditing((prev) => !prev)}>
                <EditIcon />
              </IconButton> */}
              </div>
              <h2 className="text-md font-semibold text-[#2663EB] flex items-center justify-start mb-4 gap-2">
                <PhoneIcon className="text-[#2663EB]" /> CONTACT & ADDRESS
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-sm text-gray-700">
                {/* Work Mobile */}
                <TextField
                  label="Work Mobile"
                  // placeholder="Type Mobile Number Here"
                  name="WorkMobile"
                  id="WorkMobile"
                  // type="number"
                  type="text"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.WorkMobile}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  error={
                    formik.touched.WorkMobile &&
                    Boolean(formik.errors.WorkMobile)
                  }
                  helperText={
                    formik.touched.WorkMobile && formik.errors.WorkMobile
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIphoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Personal Phone */}
                <TextField
                  // label="Personal Phone"
                  label="Emergency Contact Phone"
                  // placeholder="Type Phone Number Here"
                  name="PersonalPhone"
                  id="PersonalPhone"
                  // type="number"
                  type="text"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.PersonalPhone}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  error={
                    formik.touched.PersonalPhone &&
                    Boolean(formik.errors.PersonalPhone)
                  }
                  helperText={
                    formik.touched.PersonalPhone && formik.errors.PersonalPhone
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Home Airport */}
                <TextField
                  label="Home Airport"
                  // placeholder="Type Your Home Airport Here"
                  name="HomeAirport"
                  id="HomeAirport"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.HomeAirport}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  error={
                    formik.touched.HomeAirport &&
                    Boolean(formik.errors.HomeAirport)
                  }
                  helperText={
                    formik.touched.HomeAirport && formik.errors.HomeAirport
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FlightTakeoffIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Work Phone */}
                <TextField
                  // label="Work Phone"
                  label="Personal Mobile"
                  // placeholder="Type Phone Number Here"
                  name="WorkPhone"
                  id="WorkPhone"
                  // type="number"
                  type="text"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.WorkPhone}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  error={
                    formik.touched.WorkPhone && Boolean(formik.errors.WorkPhone)
                  }
                  helperText={
                    formik.touched.WorkPhone && formik.errors.WorkPhone
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Personal Mobile */}
                <TextField
                  // label="Personal Mobile"
                  label="Emergency Contact"
                  // placeholder="Type Mobile Number Here"
                  name="PersonalMobile"
                  id="PersonalMobile"
                  // type="number"
                  type="text"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.PersonalMobile}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  error={
                    formik.touched.PersonalMobile &&
                    Boolean(formik.errors.PersonalMobile)
                  }
                  helperText={
                    formik.touched.PersonalMobile &&
                    formik.errors.PersonalMobile
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIphoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Home Address */}
                <TextField
                  label="Home Address"
                  // placeholder="Type Your Address Here"
                  name="HomeAddress"
                  id="HomeAddress"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.HomeAddress}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  error={
                    formik.touched.HomeAddress &&
                    Boolean(formik.errors.HomeAddress)
                  }
                  helperText={
                    formik.touched.HomeAddress && formik.errors.HomeAddress
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <HomeIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Work Email */}
                <TextField
                  label="Work Email"
                  // placeholder="Type Email Here"
                  name="WorkEmail"
                  id="WorkEmail"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.WorkEmail}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  error={
                    formik.touched.WorkEmail && Boolean(formik.errors.WorkEmail)
                  }
                  helperText={
                    formik.touched.WorkEmail && formik.errors.WorkEmail
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Personal Email */}
                <TextField
                  label="Personal Email"
                  // placeholder="Type Email Here"
                  name="PersonalEmail"
                  id="PersonalEmail"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.PersonalEmail}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  error={
                    formik.touched.PersonalEmail &&
                    Boolean(formik.errors.PersonalEmail)
                  }
                  helperText={
                    formik.touched.PersonalEmail && formik.errors.PersonalEmail
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Current Address */}
                <TextField
                  label="Current Address"
                  // placeholder="Type Your Address Here"
                  name="CurrentAddress"
                  id="CurrentAddress"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.CurrentAddress}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  error={
                    formik.touched.CurrentAddress &&
                    Boolean(formik.errors.CurrentAddress)
                  }
                  helperText={
                    formik.touched.CurrentAddress &&
                    formik.errors.CurrentAddress
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LocationOnIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </CardContent>
          </Card>

          <Card className="shadow-md p-2">
            <CardContent className="relative">
              <div className="absolute top-4 right-4">
                {/* <IconButton onClick={() => setIsEditing((prev) => !prev)}>
        <EditIcon />
      </IconButton> */}
              </div>
              <h2 className="text-md font-semibold text-[#2663EB] flex items-center justify-start mb-4 gap-2">
                <WorkIcon className="text-[#2663EB]" /> EMPLOYMENT OVERVIEW
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-sm text-gray-700">
                {/* Join Date */}
                {/* <TextField
                  label="Join Date"
                  type="date"
                  name="JoinDate"
                  id="JoinDate"
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  className="inpBackColor"
                  value={formik.values.JoinDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  error={
                    formik.touched.JoinDate && Boolean(formik.errors.JoinDate)
                  }
                  helperText={formik.touched.JoinDate && formik.errors.JoinDate}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EventIcon />
                      </InputAdornment>
                    ),
                  }}
                /> */}

                {/* Shift Group */}
                {/* <TextField
                  label="Shift Group"
                  name="ShiftGroup"
                  id="ShiftGroup"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.ShiftGroup}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccessTimeIcon />
                      </InputAdornment>
                    ),
                  }}
                /> */}

                <div className="flex justify-between items-center gap-2">
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="division-label">Shift Group</InputLabel>
                    <Select
                      labelId="division-label"
                      name="ShiftGroup"
                      value={formik.values.ShiftGroup}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      startAdornment={
                        <AccessTimeIcon className="mr-2 text-gray-500" />
                      }
                      label="Shift Group"
                    >
                      <MenuItem>
                        <em>Select Grade</em>
                      </MenuItem>
                      {shiftGroupListFromAPI?.map((item, index) => (
                        <MenuItem key={index} value={item.Description}>
                          {item.Description}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <button
                    type="button"
                    onClick={() => setShowShiftGroupCreationEditPopup(true)}
                    className={` px-2 py-1 font-semibold rounded-md bg-blue-500 hover:bg-blue-700  text-white`}
                  >
                    Manage
                  </button>
                </div>

                {/* Agent ID */}
                <TextField
                  label="Agent ID"
                  name="AgentID"
                  id="AgentID"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.AgentID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <BadgeIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Job Title */}
                <div className="flex justify-between items-center gap-2">
                  <FormControl
                    variant="outlined"
                    fullWidth
                    // disabled={!isEditing}
                    error={
                      formik.touched.JobTitle && Boolean(formik.errors.JobTitle)
                    }
                  >
                    <InputLabel id="job-title-label">Job Title</InputLabel>
                    <Select
                      labelId="job-title-label"
                      id="JobTitle"
                      name="JobTitle"
                      value={formik.values.JobTitle}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      startAdornment={
                        <InputAdornment position="start">
                          <WorkOutlineIcon />
                        </InputAdornment>
                      }
                      label="Job Title"
                    >
                      <MenuItem>
                        <em>Select Job Title</em>
                      </MenuItem>
                      {/* {Array.isArray(empState) &&
                        empState.map((d, i) => (
                          <MenuItem key={i} value={d.Description}>
                            {d.Description}
                          </MenuItem>
                        ))} */}
                      {Array.isArray(jobTitleListFromAPI) &&
                        jobTitleListFromAPI.map((d, i) => (
                          <MenuItem key={i} value={d.Description}>
                            {d.Description}
                          </MenuItem>
                        ))}
                    </Select>
                    {formik.touched.JobTitle && formik.errors.JobTitle && (
                      <div className="text-red-500 text-sm mt-1">
                        {formik.errors.JobTitle}
                      </div>
                    )}
                  </FormControl>

                  <button
                    type="button"
                    onClick={() => setShowJobTitleCreationEditPopup(true)}
                    className="bg-blue-500 hover:bg-blue-700 px-2 py-1 text-white font-semibold rounded-md"
                  >
                    Manage
                  </button>
                </div>

                {/* Division */}
                {/* <TextField
                  label="Division"
                  name="Division"
                  id="Division"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.Division}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <GroupWork className="mr-2 text-gray-500" />

                      </InputAdornment>
                    ),
                  }}
                /> */}

                <div className="flex justify-between items-center gap-2">
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="division-label">Division</InputLabel>
                    <Select
                      labelId="division-label"
                      name="Division"
                      value={formik.values.Division}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      startAdornment={
                        <ApartmentIcon className="mr-2 text-gray-500" />
                      }
                      label="Division"
                    >
                      <MenuItem>
                        <em>Select Division</em>
                      </MenuItem>
                      {divisionListFromAPI?.map((item, index) => (
                        <MenuItem key={index} value={item.Description}>
                          {item.Description}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <button
                    type="button"
                    onClick={() => setShowDivisionCreationEditPopup(true)}
                    className="bg-blue-500 hover:bg-blue-700 px-2 py-1 text-white font-semibold rounded-md"
                  >
                    Manage
                  </button>
                </div>

                {/* Bank Name */}
                <TextField
                  label="Bank Name"
                  name="BankName"
                  id="BankName"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.BankName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountBalanceIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Job Type */}
                <FormControl
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                >
                  <InputLabel id="job-type-label">
                    {/* <CategoryIcon style={{ marginRight: "6px", verticalAlign: "middle" }} /> */}
                    Job Type
                  </InputLabel>
                  <Select
                    labelId="job-type-label"
                    id="JobType"
                    name="JobType"
                    value={formik.values.JobType}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    startAdornment={
                      <InputAdornment position="start">
                        <CategoryIcon />
                      </InputAdornment>
                    }
                    label="Job Tye"
                  >
                    <MenuItem value="Full Time">Full Time</MenuItem>
                    <MenuItem value="Part Time">Part Time</MenuItem>
                  </Select>
                </FormControl>

                {/* Grade */}
                {/* <TextField
                  label="Grade"
                  name="Grade"
                  id="Grade"
                  variant="outlined"
                  fullWidth
                  className="inpBackColor"
                  value={formik.values.Grade}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <StarHalfIcon />
                      </InputAdornment>
                    ),
                  }}
                /> */}

                <div className="flex justify-between items-center gap-2">
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="division-label">Grade</InputLabel>
                    <Select
                      labelId="division-label"
                      name="Grade"
                      value={formik.values.Grade}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      startAdornment={
                        <StarHalfIcon className="mr-2 text-gray-500" />
                      }
                      label="Division"
                    >
                      <MenuItem>
                        <em>Select Grade</em>
                      </MenuItem>
                      {gradeListFromAPI?.map((item, index) => (
                        <MenuItem key={index} value={item.Description}>
                          {item.Description}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <button
                    type="button"
                    onClick={() => setShowGradeCreationEditPopup(true)}
                    className={` px-2 py-1 font-semibold rounded-md bg-blue-500 hover:bg-blue-700  text-white`}
                  >
                    Manage
                  </button>
                </div>

                <TextField
                  label="Bank Account No / IBAN"
                  name="BankAccountNo"
                  id="BankAccountNo"
                  variant="outlined"
                  fullWidth
                  // type="number"
                  type="text"
                  className="inpBackColor"
                  value={formik.values.BankAccountNo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountBalanceWalletIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="relative">
              {/* className="absolute to-*?":/>< */}

              {/* <Typography variant="h6" gutterBottom>
                {/* <TbEPassport /> 
                Payrol Values , Salary Information
              </Typography> */}

              <h2 className="text-md font-semibold text-[#2663EB] flex items-center justify-start mb-4 ">
                <IconButton>
                  <EditIcon className="text-[#2663EB]" />
                </IconButton>{" "}
                PAYROL VALUES , SALARY INFORMATION
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm text-gray-700">
                <div className="mb-2">
                  <TextField
                    fullWidth
                    id="BasicPay"
                    name="BasicPay"
                    // label="Input Basic Pay Here"
                    label="Initial Basic Pay"
                    variant="outlined"
                    type="number"
                    // onChange={(e) => setbasicPay(parseInt(e.target.value))}
                    onChange={formik.handleChange("BasicPay")}
                  />
                </div>

                {/* <div style={{ marginBottom: "16px" }}>
                  <TextField
                    variant="outlined"
                    label="Initial Basic Pay"
                    id="InitBasicPay"
                    name="BasicPay"
                    type="number"
                    onChange={formik.handleChange("BasicPay")}
                    onBlur={formik.handleBlur("BasicPay")}
                    value={formik.values.BasicPay}
                    disabled
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              setbasicPay(formik.values.BasicPay + IncTotal)
                            }
                            size="small"
                          >
                            <MdAddChart />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div> */}

                <div style={{ marginBottom: "16px" }}>
                  <TextField
                    variant="outlined"
                    label="Increments Total"
                    id="Allowances_NOT"
                    type="number"
                    name="Allowances_NOT"
                    onChange={formik.handleChange("Allowances_NOT")}
                    onBlur={formik.handleBlur("Allowances_NOT")}
                    placeholder={IncTotal}
                    // value={formik.values.Allowances_NOT}
                    value={incrementAmountSum}
                    disabled
                    fullWidth
                  />
                </div>

                {/* <div style={{ marginBottom: "16px" }}>
                  <TextField
                    variant="outlined"
                    label="NetBasic Salary"
                    id="NetBasicSalary"
                    type="number"
                    name="NetBasicSalary"
                    onChange={formik.handleChange("NetBasicSalary")}
                    onBlur={formik.handleBlur("NetBasicSalary")}
                    placeholder={
                      basicPay + IncTotal ? basicPay + IncTotal : "0"
                    }
                    value={formik.values.NetBasicSalary}
                    disabled
                    fullWidth
                  />
                </div> */}

                <div style={{ marginBottom: "16px" }}>
                  <TextField
                    variant="outlined"
                    disabled
                    label="Net Basic Salary"
                    type="number"
                    id="exampleInputPassword1"
                    name="OTrate"
                    onChange={formik.handleChange("OTrate")}
                    onBlur={formik.handleBlur("OTrate")}
                    // value={formik.values.OTrate}
                    value={formik.values.BasicPay + incrementAmountSum}
                    fullWidth
                  />
                </div>

                <div style={{ marginBottom: "16px" }}>
                  <TextField
                    variant="outlined"
                    label="Allowances"
                    type="number"
                    name="Allowances_OT"
                    onChange={formik.handleChange("Allowances_OT")}
                    onBlur={formik.handleBlur("Allowances_OT")}
                    // value={formik.values.Allowances_OT}
                    value={allowanceAmountSum}
                    placeholder={AlvTotal}
                    disabled
                    fullWidth
                  />
                </div>

                <div style={{ marginBottom: "16px" }}>
                  <TextField
                    variant="outlined"
                    label="Net Salary"
                    type="number"
                    name="NetSalary"
                    onChange={formik.handleChange("NetSalary")}
                    onBlur={formik.handleBlur("NetSalary")}
                    // value={formik.values.NetSalary}
                    value={
                      formik.values.BasicPay +
                      incrementAmountSum +
                      allowanceAmountSum
                    }
                    placeholder={
                      basicPay ? basicPay + AlvTotal + IncTotal : null
                    }
                    disabled
                    fullWidth
                  />
                </div>

                <div style={{ marginBottom: "16px" }}>
                  <TextField
                    variant="outlined"
                    label="TimeSheet Category"
                    select
                    onChange={handleAddrTypeChange}
                    fullWidth
                  >
                    <MenuItem>
                      <em>Select Category</em>
                    </MenuItem>
                    <MenuItem value="1">Calender Days</MenuItem>
                    <MenuItem value="2">Hourly Wage</MenuItem>
                  </TextField>
                </div>

                <div style={{ marginBottom: "16px" }}>
                  <TextField
                    variant="outlined"
                    label="Normal Hrs"
                    type="number"
                    name="NormalHrs"
                    onChange={formik.handleChange("NormalHrs")}
                    onBlur={formik.handleBlur("NormalHrs")}
                    value={formik.values.NormalHrs}
                    disabled={Category === "1" ? false : true}
                    fullWidth
                  />
                </div>

                <div style={{ marginBottom: "16px" }}>
                  <TextField
                    variant="outlined"
                    label="Hourly Wage"
                    type="text"
                    name="HourlyWage"
                    onChange={formik.handleChange("HourlyWage")}
                    onBlur={formik.handleBlur("HourlyWage")}
                    value={formik.values.HourlyWage}
                    placeholder="0.00"
                    disabled={Category === "2" ? false : true}
                    fullWidth
                  />
                </div>

                <div style={{ marginBottom: "16px" }}>
                  <TextField
                    variant="outlined"
                    label="Ot Rate"
                    // type="text"
                    type="number"
                    name="OTrate"
                    onChange={formik.handleChange("OTrate")}
                    onBlur={formik.handleBlur("OTrate")}
                    value={formik.values.OTrate}
                    fullWidth
                  />
                </div>

                <div style={{ marginBottom: "16px" }}>
                  <TextField
                    variant="outlined"
                    label="Special Ot Rate"
                    // type="text"
                    type="number"
                    name="SplOtRate"
                    onChange={formik.handleChange("SplOtRate")}
                    onBlur={formik.handleBlur("SplOtRate")}
                    value={formik.values.SplOtRate}
                    fullWidth
                  />
                </div>

                <div style={{ marginBottom: "16px" }}>
                  <TextField
                    variant="outlined"
                    // label="Regular Time"
                    // type="time"
                    label="Regular Date & Time"
                    type="datetime-local"
                    name="regularTime"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.regularTime}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <AccessTimeIcon className="mr-2 text-[#757575]" />
                      ),
                    }}
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Right Column - Contact + Employment + Tags */}
        <div className="space-y-4">
          {/* Contact Info */}
          <Card className="shadow-md p-1">
            <CardContent className="relative">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-md font-semibold text-[#2663EB] flex items-center justify-start mb-4 gap-2">
                    <PassportIcon className="text-[#2663EB]" /> DOCUMENTS
                  </h2>
                </div>
                {/* Passport Image Upload */}
                <div>
                  <FormControl fullWidth className="mb-1">
                    {/* Paperclip Icon Button */}
                    <div className="flex items-center gap-2">
                      <button
                        type="button"
                        onClick={() => fileInputRef.current.click()}
                        className="p-2 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700"
                        title="Attach file"
                      >
                        <HiPaperClip className="w-5 h-5" />
                      </button>

                      {/* Display selected file name */}
                      <span className="text-sm text-gray-700 truncate max-w-xs">
                        {formik.values.photo?.name || "No file selected"}
                      </span>
                    </div>

                    {/* Hidden file input */}
                    <input
                      ref={fileInputRef}
                      type="file"
                      id="photo"
                      name="photo"
                      accept="image/*"
                      onChange={(event) =>
                        formik.setFieldValue(
                          "photo",
                          event.currentTarget.files[0],
                        )
                      }
                      onBlur={formik.handleBlur}
                      className="hidden"
                    />

                    {/* Validation Error */}
                    {formik.touched.photo && formik.errors.photo && (
                      <FormHelperText error>
                        {formik.errors.photo}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <h2 className="text-gray-600 text-[0.8rem] mb-4">
                    Document Attachment
                  </h2>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700">
                {/* </div> */}
                {/* </CardContent>
          </Card> */}

                {/* Other Details */}

                {/*<Card className="shadow-md p-1">
            <CardContent className="relative">
              <div className="absolute top-4 right-4">
                 <IconButton onClick={() => setIsEditing((prev) => !prev)}>
        <EditIcon />
      </IconButton> 
              </div>
              <h2 className="text-xl font-semibold text-gray-600 flex items-center justify-start mb-4 gap-2">
                <BadgeIcon className="text-[#757575]" /> Other Details
              </h2>*/}

                {/* <div className="grid grid-cols-1 sm:grid-cols-2  gap-6 text-sm text-gray-700"> */}
                <TextField
                  label="Emirates ID"
                  name="EmiratesId"
                  id="EmiratesId"
                  variant="outlined"
                  fullWidth
                  value={formik.values.EmiratesId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  error={
                    formik.touched.EmiratesId &&
                    Boolean(formik.errors.EmiratesId)
                  }
                  helperText={
                    formik.touched.EmiratesId && formik.errors.EmiratesId
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <BadgeIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  label="Emirates ID Expiry"
                  name="EmiratesIdExpiryDate"
                  id="EmiratesIdExpiryDate"
                  type="text"
                  onFocus={(e) => (e.target.type = "date")}
                  variant="outlined"
                  fullWidth
                  value={formik.values.EmiratesIdExpiryDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarMonthIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  // label="Driving Licence No"
                  label="Person Code"
                  name="DrivingLicenceNo"
                  id="DrivingLicenceNo"
                  variant="outlined"
                  fullWidth
                  value={formik.values.DrivingLicenceNo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CreditCardIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  // label="Insurance No"
                  label="Visa File No"
                  name="InsuranceNo"
                  id="InsuranceNo"
                  variant="outlined"
                  fullWidth
                  value={formik.values.InsuranceNo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <ContactEmergencyIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  label="Visa No"
                  name="VisaNo"
                  id="VisaNo"
                  // type="number"
                  type="text"
                  variant="outlined"
                  fullWidth
                  value={formik.values.VisaNo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <VisaIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  label="Visa Expiry"
                  name="VisaExpiryDate"
                  id="VisaExpiryDate"
                  type="text"
                  onFocus={(e) => (e.target.type = "date")}
                  variant="outlined"
                  fullWidth
                  value={formik.values.VisaExpiryDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarMonthIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  // label="Person ID"
                  label="Labour Card"
                  name="PersonId"
                  id="PersonId"
                  variant="outlined"
                  fullWidth
                  value={formik.values.PersonId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  // label="Person ID Expiry"
                  label="Labour Card Expiry"
                  name="PersonIdExpiryDate"
                  id="PersonIdExpiryDate"
                  type="text"
                  onFocus={(e) => (e.target.type = "date")}
                  variant="outlined"
                  fullWidth
                  value={formik.values.PersonIdExpiryDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarMonthIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  label="Part-time Labour No"
                  name="PartTimeLabour"
                  id="PartTimeLabour"
                  // type="number"
                  type="text"
                  variant="outlined"
                  fullWidth
                  value={formik.values.PartTimeLabour}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EngineeringIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  label="Part-time Labour Expiry"
                  name="PartTimeLabourExpiryDate"
                  id="PartTimeLabourExpiryDate"
                  type="text"
                  onFocus={(e) => (e.target.type = "date")}
                  variant="outlined"
                  fullWidth
                  value={formik.values.PartTimeLabourExpiryDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarMonthIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Passport No */}
                <TextField
                  label="Passport No"
                  className="inpBackColor"
                  name="PassportNo"
                  id="PassportNo"
                  variant="outlined"
                  fullWidth
                  value={formik.values.PassportNo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.PassportNo &&
                    Boolean(formik.errors.PassportNo)
                  }
                  helperText={
                    formik.touched.PassportNo && formik.errors.PassportNo
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PassportIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Passport Expiry Date */}
                {/* <TextField
                  label="Passport Expiry Date"
                  className="inpBackColor"
                  name="PassportExpiryDate"
                  id="PassportExpiryDate"
                  variant="outlined"
                  fullWidth
                  value={formik.values.PassportExpiryDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.PassportExpiryDate &&
                    Boolean(formik.errors.PassportExpiryDate)
                  }
                  helperText={
                    formik.touched.PassportExpiryDate &&
                    formik.errors.PassportExpiryDate
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EventIcon />
                      </InputAdornment>
                    ),
                  }}
                /> */}

                <TextField
                  label="Passport Expiry Date"
                  name="PassportExpiryDate"
                  id="PassportExpiryDate"
                  type="text"
                  onFocus={(e) => (e.target.type = "date")}
                  variant="outlined"
                  fullWidth
                  // className="inpBackColor"
                  value={formik.values.PassportExpiryDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // error={
                  //   formik.touched.PassportExpiryDate &&
                  //   Boolean(formik.errors.PassportExpiryDate)
                  // }
                  // helperText={
                  //   formik.touched.PassportExpiryDate &&
                  //   formik.errors.PassportExpiryDate
                  // }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarMonthIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Passport Place of Issue */}
                <TextField
                  label="Passport Place of Issue"
                  className="inpBackColor"
                  name="PassportPlaceofIssue"
                  id="PassportPlaceofIssue"
                  variant="outlined"
                  fullWidth
                  value={formik.values.PassportPlaceofIssue}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.PassportPlaceofIssue &&
                    Boolean(formik.errors.PassportPlaceofIssue)
                  }
                  helperText={
                    formik.touched.PassportPlaceofIssue &&
                    formik.errors.PassportPlaceofIssue
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PlaceIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Passport Country of Issue */}
                <TextField
                  label="Passport Country of Issue"
                  className="inpBackColor"
                  name="PassportCountryofIssue"
                  id="PassportCountryofIssue"
                  variant="outlined"
                  fullWidth
                  value={formik.values.PassportCountryofIssue}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.PassportCountryofIssue &&
                    Boolean(formik.errors.PassportCountryofIssue)
                  }
                  helperText={
                    formik.touched.PassportCountryofIssue &&
                    formik.errors.PassportCountryofIssue
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CountryIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Passport Issue Date */}
                <TextField
                  label="Passport Issue Date"
                  className="inpBackColor"
                  name="PassportIssueDate"
                  id="PassportIssueDate"
                  variant="outlined"
                  fullWidth
                  value={formik.values.PassportIssueDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  onFocus={(e) => (e.target.type = "date")}
                  onBlurCapture={(e) => {
                    if (!formik.values.PassportIssueDate)
                      e.target.type = "text";
                  }}
                  error={
                    formik.touched.PassportIssueDate &&
                    Boolean(formik.errors.PassportIssueDate)
                  }
                  helperText={
                    formik.touched.PassportIssueDate &&
                    formik.errors.PassportIssueDate
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EventIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Passport Image Upload
                <FormControl fullWidth className="inpBackColor ">
                  <FormLabel
                    htmlFor="photo"
                    className="text-gray-600 text-[10px] flex items-center gap-2"
                  >
                    <ImageIcon />
                    <span className="text-gray-600 text-[12px]">
                      Document Attachment
                    </span>
                  </FormLabel>
                  <Input
                    id="photo"
                    name="photo"
                    type="file"
                    onChange={(event) =>
                      formik.setFieldValue(
                        "photo",
                        event.currentTarget.files[0]
                      )
                    }
                    onBlur={formik.handleBlur}
                    disableUnderline
                    inputProps={{ accept: "image/*" }}
                  />
                  {formik.touched.photo && formik.errors.photo && (
                    <FormHelperText error>{formik.errors.photo}</FormHelperText>
                  )}
                </FormControl> */}
                {/* <div></div> */}

                <TextField
                  label="Licence Expiry Date"
                  name="DrivingLicenceExpiryDate"
                  id="DrivingLicenceExpiryDate"
                  type="text"
                  onFocus={(e) => (e.target.type = "date")}
                  variant="outlined"
                  fullWidth
                  value={formik.values.DrivingLicenceExpiryDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarMonthIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  label="Insurance Expiry"
                  name="InsuranceExpiryDate"
                  id="InsuranceExpiryDate"
                  type="text"
                  onFocus={(e) => (e.target.type = "date")}
                  variant="outlined"
                  fullWidth
                  value={formik.values.InsuranceExpiryDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // disabled={!isEditing}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarMonthIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              {/* <Typography
                variant="h6"
                style={{
                  marginBottom: "16px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <GpsFixedIcon style={{ marginRight: "8px" }} />
                GPS Coordinates
              </Typography> */}

              <h2 className="text-md font-semibold text-[#2663EB] flex items-center justify-start mb-4 gap-2">
                <GpsFixedIcon className="text-[#2663EB]" /> GPS COORDINATES
              </h2>

              <div style={{ marginBottom: "16px" }}>
                <TextField
                  variant="outlined"
                  label="Latitude"
                  type="text"
                  // class="form-control inpBackColor"
                  id="Latitude"
                  name="Latitude"
                  onChange={formik.handleChange("Latitude")}
                  onBlur={formik.handleBlur("Latitude")}
                  value={formik.values.Latitude}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MyLocationIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <TextField
                  variant="outlined"
                  label="longitude"
                  type="text"
                  name="longitude"
                  onChange={formik.handleChange("longitude")}
                  onBlur={formik.handleBlur("longitude")}
                  value={formik.values.longitude}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PublicIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                <RoomIcon style={{ marginRight: "8px" }} />
                <Typography variant="body1" style={{ marginRight: "8px" }}>
                  Activate Geofencing
                </Typography>
                <Switch
                  checked={formik.values.Geofencing || false}
                  onChange={(e) =>
                    formik.setFieldValue("Geofencing", e.target.checked)
                  }
                  name="Geofencing"
                />
              </div>
            </CardContent>
          </Card>

          {/* Tags */}
          <Card>
            <CardContent>
              {/* <Typography variant="h6" style={{ marginBottom: "16px" }}>
                {/* <MdContactEmergency /> 
                &nbsp;Account Setting
              </Typography> */}

              <h2 className="text-md font-semibold text-[#2663EB] flex items-center justify-start mb-4 gap-2">
                <ManageAccountsIcon className="text-[#2663EB]" /> ACCOUNT
                SETTING
              </h2>

              {/* <div style={{ marginBottom: "16px" }}>
                <TextField
                  variant="outlined"
                  label="Hourly Wage"
                  // type="text"
                  type="number"
                  onFocus={(e) => (e.target.type = "date")}
                  name="HourlyWage"
                  onChange={formik.handleChange("HourlyWage")}
                  onBlur={formik.handleBlur("HourlyWage")}
                  value={formik.values.HourlyWage}
                  fullWidth
                />
              </div> */}

              <div style={{ marginBottom: "16px" }}>
                <TextField
                  variant="outlined"
                  label="Salary Payable"
                  name="SalaryAc"
                  onChange={formik.handleChange("SalaryAc")}
                  onBlur={formik.handleBlur("SalaryAc")}
                  value={SalaryPayment ? SalaryPayment : formik.values.SalaryAc}
                  disabled
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModalsalary"
                          size="small"
                        >
                          <MdMenuOpen />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <SalaryPayablePopup SalaryPayable={SalaryPayable} />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <TextField
                  variant="outlined"
                  label="Salary Expense"
                  type="text"
                  name="AdvanceAc"
                  onChange={formik.handleChange("AdvanceAc")}
                  onBlur={formik.handleBlur("AdvanceAc")}
                  value={formik.values.AdvanceAc}
                  fullWidth
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <TextField
                  variant="outlined"
                  label="Loans & Advances"
                  type="text"
                  name="Notes"
                  onChange={formik.handleChange("Notes")}
                  onBlur={formik.handleBlur("Notes")}
                  value={formik.values.Notes}
                  fullWidth
                />
              </div>
              {/* </div> */}
            </CardContent>
          </Card>
        </div>

        <div className="lg:col-span-3">
          <Card className="shadow-md p-2">
            <CardContent className="relative">
              <div className="row mt-2  col-span-3">
                <div className="col-md-6">
                  {/* <h6 className="mb-2 sub-head mt-3">
                    <MdContactEmergency />
                    &nbsp;Allowance Creation{" "}
                  </h6> */}
                  <h2 className="text-md font-semibold text-[#2663EB] flex items-center justify-start mb-4 gap-2">
                    <PaymentsIcon className="text-[#2663EB]" /> ALLOWANCE
                    CREATION
                  </h2>
                </div>
                {/* <div className="col-md-6">
                  <div className="text-end">
                    <Link to={"createAllowance"}>
                      <button
                        className="dash-btn"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModalcreate"
                      >
                        Create
                      </button>
                    </Link>
                  </div>
                </div> */}
                <div className="col-md-12">
                  <CreateAllowance
                    calculationAlv={calculationAlv}
                    EmpIdTop={EmpIdTop}
                    getAllowanceList={getAllowanceList}
                  />

                  {/* Allowance List  */}
                  <div className="max-h-60 overflow-x-auto mt-4">
                    <h2 className="text-md font-semibold text-[#2663EB] flex items-center justify-start mb-4 gap-2">
                      <PaymentsIcon className="text-[#2663EB]" /> ALLOWANCE LIST
                    </h2>
                    <table className="min-w-full border border-gray-200  shadow-sm overflow-hidden ">
                      {/* Header */}
                      <thead className="bg-[#2663EB] text-white text-sm">
                        <tr>
                          <th className="px-2 py-1  font-semibold">Sl No</th>
                          <th className="px-2 py-1  font-semibold">
                            Description
                          </th>
                          <th className="px-2 py-1  font-semibold">Amount</th>
                          <th className="px-2 py-1  font-semibold">Date</th>
                          <th className="px-2 py-1  font-semibold">Reason</th>
                        </tr>
                      </thead>

                      {/* Body */}
                      <tbody className="text-sm text-gray-700">
                        {AllowanceData?.map((d, i) => (
                          <tr
                            key={i}
                            className="border-t border-gray-200 hover:bg-gray-50 transition"
                          >
                            <td className="px-4 py-3 ">{i + 1}</td>
                            <td className="px-4 py-3 ">{d.AllowanceType}</td>
                            <td className="px-4 py-3 ">{d.Amount}</td>
                            <td className="px-4 py-3 ">
                              {dayjs(d.ADate).format("DD-MMM-YYYY")}
                            </td>
                            <td className="px-4 py-3">{d.AffectOTCalc}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <CreateAllowancePopup />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="lg:col-span-3">
          <Card className="shadow-md p-2">
            <CardContent className="relative">
              <div className="row mt-2">
                <div className="col-md-6">
                  {/* <h6 className="mb-2 sub-head mt-3">
                    <MdContactEmergency />
                    &nbsp;Increment Creation{" "}
                  </h6> */}
                  <h2 className="text-md font-semibold text-[#2663EB] flex items-center justify-start mb-4 gap-2">
                    <TrendingUpIcon className="text-[#2663EB]" /> INCREMENT
                    CREATION
                  </h2>
                </div>

                <div className="col-md-12">
                  <CreateIncrement
                    calculationInc={calculationInc}
                    EmpIdTop={EmpIdTop}
                    getIncrementList={getIncrementList}
                  />
                  {/* <CreateIncrementPopup /> */}

                  {/* Increment List  */}
                  <div className="max-h-60 overflow-x-auto mt-4">
                    <h2 className="text-md font-semibold text-[#2663EB] flex items-center justify-start mb-4 gap-2">
                      <TrendingUpIcon className="text-[#2663EB]" /> INCREMENT
                      LIST
                    </h2>
                    <table className="min-w-full border border-gray-200  shadow-sm overflow-hidden ">
                      {/* Header */}
                      <thead className="bg-[#2663EB] text-white text-sm">
                        <tr>
                          <th className="px-2 py-1  font-semibold">Sl No</th>
                          <th className="px-2 py-1  font-semibold">
                            Description
                          </th>
                          <th className="px-2 py-1  font-semibold">Amount</th>
                          <th className="px-2 py-1  font-semibold">Date</th>
                          <th className="px-2 py-1  font-semibold">Reason</th>
                        </tr>
                      </thead>

                      {/* Body */}
                      <tbody className="text-sm text-gray-700">
                        {IncrementData?.map((d, i) => (
                          <tr
                            key={i}
                            className="border-t border-gray-200 hover:bg-gray-50 transition"
                          >
                            <td className="px-4 py-3 ">{i + 1}</td>
                            <td className="px-4 py-3 ">{d.AllowanceType}</td>
                            <td className="px-4 py-3 ">{d.Amount}</td>
                            <td className="px-4 py-3 ">
                              {dayjs(d.ADate).format("DD-MMM-YYYY ")}
                            </td>
                            <td className="px-4 py-3">{d.AffectOTCalc}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="lg:col-span-3">
          <Card className="shadow-md p-2">
            <CardContent className="relative">
              {/* <div className="bg-white shadow-md rounded-lg p-4"> */}
              <div className="flex items-center justify-between mb-4">
                {/* <h2 className="text-base font-semibold text-gray-700 flex items-center gap-2">
                <GiThreeLeaves className="text-green-600" />
                Leave Information
              </h2> */}
                <h2 className="text-md font-semibold text-[#2663EB] flex items-center justify-start mb-4 gap-2">
                  <CalendarMonthIcon className="text-[#2663EB]" /> LEAVE
                  INFORMATION
                </h2>
              </div>
              <div className="mb-6">
                <h3 className="text-sm font-semibold text-gray-800 mb-2 flex items-center gap-2">
                  <IoTime className="text-blue-600" />
                  <span className="text-[#2663EB]"> Current Leave Status </span>
                </h3>

                <div className="overflow-x-auto">
                  <table className="min-w-full text-sm border text-gray-700 rounded-lg shadow-sm">
                    <thead className="bg-[#2663EB] text-white text-sm">
                      <tr>
                        <th className="px-2 py-1  font-semibold">
                          Leave Category
                        </th>
                        <th className="px-2 py-1  font-semibold">Allotted</th>
                        <th className="px-2 py-1  font-semibold">Consumed</th>
                        <th className="px-2 py-1  font-semibold">Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="bg-white border-t shadow-sm">
                        <td className="p-2"> </td>
                        <td className="p-2"> </td>
                        <td className="p-2"> </td>
                        <td className="p-2"> </td>
                      </tr>

                      {/* {leaveStatusData &&
                        leaveStatusData.map((item, index) => (
                          <tr className="bg-white border-t shadow-sm">
                            <td className="p-2">{item.LEAVECATEGORY}</td>
                            <td className="p-2">{item.ALLOTED}</td>
                            <td className="p-2">{item.CONSUMED}</td>
                            <td className="p-2">{item.Balance}</td>
                          </tr>
                        ))} */}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="mt-8">
                <h3 className="text-sm font-semibold text-gray-800 mb-2 flex items-center gap-2">
                  <IoDocumentText className="text-[#2663EB]" />
                  <span className="text-[#2663EB]">
                    Leave History of Employee
                  </span>
                </h3>

                <div className="overflow-x-auto">
                  <table className="min-w-full text-sm border text-gray-700 rounded-lg">
                    <thead className="bg-[#2663EB] text-white text-sm">
                      <tr>
                        <th className="px-2 py-1  font-semibold">
                          Leave Category
                        </th>
                        <th className="px-2 py-1  font-semibold">
                          Application Date
                        </th>
                        <th className="px-2 py-1  font-semibold">From Date</th>
                        <th className="px-2 py-1  font-semibold">To Date</th>
                        <th className="px-2 py-1  font-semibold">Leaves</th>
                        <th className="px-2 py-1  font-semibold">Notes</th>
                        <th className="px-2 py-1  font-semibold">Ticket</th>
                        <th className="px-2 py-1  font-semibold">Status</th>
                        <th className="px-2 py-1  font-semibold">
                          Approved By
                        </th>
                        <th className="px-2 py-1  font-semibold">
                          Approved Date
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="bg-white border-t">
                        <td className="p-2"> </td>
                        <td className="p-2"> </td>
                        <td className="p-2"> </td>
                        <td className="p-2"> </td>
                        <td className="p-2"> </td>
                        <td className="p-2"> </td>
                        <td className="p-2"> </td>
                        <td className="p-2 text-green-600"> </td>
                        <td className="p-2"> </td>
                        <td className="p-2"> </td>
                      </tr>

                      {/* // <tr className="bg-white border-t">
                          //   <td className="p-2">{item.Leave_Type}</td>
                          //   <td className="p-2">{dayjs(item?.FROM_DT).format('DD-MMM-YYYY ')}</td>
                          //   <td className="p-2">{dayjs(item?.TO_DATE).format('DD-MMM-YYYY ')}</td>
                          //   <td className="p-2">{dayjs(item?.APRV_DT).format('DD-MMM-YYYY ')}</td>
                          //   <td className="p-2">{item.LEAVES}</td>
                          //   <td className="p-2">{dayjs(item?.REJOIN_DATE).format('DD-MMM-YYYY ')}</td>
                          //   <td className="p-2">{item.Status}</td>
                          //   <td className="p-2 text-green-600">{item.NOTES}</td>
                          //   <td className="p-2">{item.Ticket}</td>
                          //   <td className="p-2">{item.APRD_BY}</td>
                          //   <td className="p-2">{dayjs(item?.NEXT_EXP_LEAVE).format('DD-MMM-YYYY ')}</td>
                          // </tr> */}
                      {/* {leaveHistoryData &&
                        leaveHistoryData.map((item, index) => ( */}
                      {/* <tr className="bg-white border-t">
                            <td className="p-2">{item.slno}</td>
                            <td className="p-2">{item.Leave_Type}</td>

                            <td className="p-2">
                              {item["FROM-DT"]
                                ? dayjs(item["FROM-DT"]).format("DD-MMM-YYYY ")
                                : "-"}
                            </td>

                            <td className="p-2">
                              {item["TO-DATE"]
                                ? dayjs(item["TO-DATE"]).format("DD-MMM-YYYY ")
                                : "-"}
                            </td>

                            <td className="p-2">
                              {item["APRV - DT"]
                                ? dayjs(item["APRV - DT"]).format("DD-MMM-YYYY ")
                                : "-"}
                            </td>

                            <td className="p-2">{item.LEAVES}</td>

                            <td className="p-2">
                              {item.Re_joinOn
                                ? dayjs(item.Re_joinOn).format("DD-MMM-YYYY ")
                                : "-"}
                            </td>

                            <td className="p-2">{item.Status}</td>

                            <td className="p-2 text-green-600">{item.NOTES}</td>

                            <td className="p-2">{item.Ticket}</td>

                            <td className="p-2">{item.APRD_BY}</td>

                            <td className="p-2">
                              {item.NEXT_EXP_LEAVE
                                ? dayjs(item.NEXT_EXP_LEAVE).format(
                                    "DD-MMM-YYYY ",
                                  )
                                : "-"}
                            </td>
                          </tr>
                        ))} */}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* </div> */}
            </CardContent>
          </Card>
        </div>

        {/* /////</div> */}

        {/* <MasterJobTablePopUp empState={empState} getData={getData} /> */}

        {showDepartmentCreationEditPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            {/* Modal Card */}
            <div className="w-[95%] max-w-xl bg-white rounded-2xl shadow-2xl p-6 max-h-[60vh] overflow-y-auto scrollbar-none">
              {/* Header */}
              <div className="flex items-center justify-between border-b pb-3">
                <h2 className="text-lg font-semibold text-[#2663EB] flex items-center gap-2">
                  <BusinessIcon className="text-[#2663EB]" />
                  DEPARTMENT MANAGEMENT
                </h2>

                <button
                  onClick={() => setShowDepartmentCreationEditPopup(false)}
                  className="p-2 rounded-full hover:bg-gray-100 transition"
                >
                  <CloseIcon />
                </button>
              </div>

              {/* Add New Branch */}
              <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
                <input
                  value={branchNameInInputBoxNew.branch_name}
                  type="text"
                  placeholder="Enter new dept name here..."
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                  onChange={(e) =>
                    setBranchNameInInputBoxNew((prev) => ({
                      ...prev,
                      branch_name: e.target.value,
                    }))
                  }
                />

                <button
                  type="button"
                  onClick={newDepartmentAPI}
                  className="
    inline-flex items-center gap-2
    bg-blue-500
    text-white
    w-1/2
    px-2 py-1
    text-sm font-semibold
    rounded-md
    shadow-lg
    hover:from-blue-700 hover:to-blue-600
    active:scale-95
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
  "
                >
                  <Plus size={16} />
                  Add Department
                </button>
              </div>

              {/* Branch List */}
              <div className="mt-6 space-y-3">
                {departmentLisFromAPI?.map((item) => {
                  const isEditing =
                    branchNameInInputBoxEdit.transaction_id
                      ?.trim()
                      ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                  return (
                    <div
                      key={item.TranId}
                      className="border border-gray-200 rounded-xl px-2 py-1 hover:shadow-md transition"
                    >
                      {/* Row Header */}
                      <div className="flex items-center justify-between">
                        <span className="font-medium text-gray-700">
                          {item.Description}
                        </span>

                        <button
                          type="button"
                          onClick={() =>
                            setBranchNameInInputBoxEdit({
                              branch_name: item.Description,
                              transaction_id: item.TranId,
                            })
                          }
                          className="p-2 rounded-md hover:bg-gray-100 transition"
                        >
                          <EditIcon
                            fontSize="small"
                            className="text-gray-600"
                          />
                        </button>
                      </div>

                      {/* Edit Section */}
                      {isEditing && (
                        <div className="mt-4 flex flex-col sm:flex-row gap-3">
                          <input
                            type="text"
                            value={branchNameInInputBoxEdit.branch_name}
                            onChange={(e) =>
                              setBranchNameInInputBoxEdit((prev) => ({
                                ...prev,
                                branch_name: e.target.value,
                              }))
                            }
                            className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                          />

                          <div className="flex gap-2">
                            <button
                              type="button"
                              onClick={() =>
                                setBranchNameInInputBoxEdit(
                                  initialBranchInActionEdit,
                                )
                              }
                              className="flex items-center gap-1 px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                            >
                              <CancelIcon fontSize="small" />
                              Cancel
                            </button>

                            <button
                              type="button"
                              onClick={editDepartmentAPI}
                              className="flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition"
                            >
                              <SaveIcon fontSize="small" />
                              Save
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {showShiftGroupCreationEditPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            {/* Modal Card */}
            <div className="w-[95%] max-w-xl bg-white rounded-2xl shadow-2xl p-6 max-h-[60vh] overflow-y-auto scrollbar-none">
              {/* Header */}
              <div className="flex items-center justify-between border-b pb-3">
                <h2 className="text-lg font-semibold text-[#2663EB] flex items-center gap-2">
                  <BusinessIcon className="text-[#2663EB]" />
                  SHIFT GROUP MANAGEMENT
                </h2>

                <button
                  onClick={() => setShowShiftGroupCreationEditPopup(false)}
                  className="p-2 rounded-full hover:bg-gray-100 transition"
                >
                  <CloseIcon />
                </button>
              </div>

              {/* Add New Division */}
              <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
                <input
                  value={shiftGroupNameInInputBoxNew.shiftGroup_name}
                  type="text"
                  placeholder="Enter new shift Group name here..."
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                  onChange={(e) =>
                    setShiftGroupNameInInputBoxNew((prev) => ({
                      ...prev,
                      shiftGroup_name: e.target.value,
                    }))
                  }
                />

                <button
                  type="button"
                  onClick={newShiftGroupAPI}
                  className="
    inline-flex items-center gap-2
    bg-blue-500
    text-white
    w-1/2
    px-2 py-1
    text-sm font-semibold
    rounded-md
    shadow-lg
    hover:from-blue-700 hover:to-blue-600
    active:scale-95
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
  "
                >
                  <Plus size={16} />
                  Add Shift Group
                </button>
              </div>

              {/* Shift Group List */}
              <div className="mt-6 space-y-3">
                {shiftGroupListFromAPI?.map((item) => {
                  const isEditing =
                    shiftGroupNameInInputBoxEdit.transaction_id
                      ?.trim()
                      ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                  return (
                    <div
                      key={item.TranId}
                      className="border border-gray-200 rounded-xl px-2 py-1 hover:shadow-md transition"
                    >
                      {/* Row Header */}
                      <div className="flex items-center justify-between">
                        <span className="font-medium text-gray-700">
                          {item.Description}
                        </span>

                        <button
                          type="button"
                          onClick={() =>
                            setShiftGroupNameInInputBoxEdit({
                              division_name: item.Description,
                              transaction_id: item.TranId,
                            })
                          }
                          className="p-2 rounded-md hover:bg-gray-100 transition"
                        >
                          <EditIcon
                            fontSize="small"
                            className="text-gray-600"
                          />
                        </button>
                      </div>

                      {/* Edit Section */}
                      {isEditing && (
                        <div className="mt-4 flex flex-col sm:flex-row gap-3">
                          <input
                            type="text"
                            value={shiftGroupNameInInputBoxEdit.shiftGroup_name}
                            onChange={(e) =>
                              setShiftGroupNameInInputBoxEdit((prev) => ({
                                ...prev,
                                shiftGroup_name: e.target.value,
                              }))
                            }
                            className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                          />

                          <div className="flex gap-2">
                            <button
                              type="button"
                              onClick={() =>
                                setShiftGroupNameInInputBoxEdit(
                                  initialShiftGroupInActionEdit,
                                )
                              }
                              className="flex items-center gap-1 px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                            >
                              <CancelIcon fontSize="small" />
                              Cancel
                            </button>

                            <button
                              type="button"
                              onClick={editDivisionAPI}
                              className="flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition"
                            >
                              <SaveIcon fontSize="small" />
                              Save
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {showDivisionCreationEditPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            {/* Modal Card */}
            <div className="w-[95%] max-w-xl bg-white rounded-2xl shadow-2xl p-6 max-h-[60vh] overflow-y-auto scrollbar-none">
              {/* Header */}
              <div className="flex items-center justify-between border-b pb-3">
                <h2 className="text-lg font-semibold text-[#2663EB] flex items-center gap-2">
                  <BusinessIcon className="text-[#2663EB]" />
                  DIVISION MANAGEMENT
                </h2>

                <button
                  onClick={() => setShowDivisionCreationEditPopup(false)}
                  className="p-2 rounded-full hover:bg-gray-100 transition"
                >
                  <CloseIcon />
                </button>
              </div>

              {/* Add New Division */}
              <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
                <input
                  value={divisionNameInInputBoxNew.division_name}
                  type="text"
                  placeholder="Enter new division name here..."
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                  onChange={(e) =>
                    setDivisionNameInInputBoxNew((prev) => ({
                      ...prev,
                      division_name: e.target.value,
                    }))
                  }
                />

                <button
                  type="button"
                  onClick={newDivisionAPI}
                  className="
    inline-flex items-center gap-2
    bg-blue-500
    text-white
    w-1/2
    px-2 py-1
    text-sm font-semibold
    rounded-md
    shadow-lg
    hover:from-blue-700 hover:to-blue-600
    active:scale-95
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
  "
                >
                  <Plus size={16} />
                  Add Division
                </button>
              </div>

              {/* Division List */}
              <div className="mt-6 space-y-3">
                {divisionListFromAPI?.map((item) => {
                  const isEditing =
                    divisionNameInInputBoxEdit.transaction_id
                      ?.trim()
                      ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                  return (
                    <div
                      key={item.TranId}
                      className="border border-gray-200 rounded-xl px-2 py-1 hover:shadow-md transition"
                    >
                      {/* Row Header */}
                      <div className="flex items-center justify-between">
                        <span className="font-medium text-gray-700">
                          {item.Description}
                        </span>

                        <button
                          type="button"
                          onClick={() =>
                            setDivisionNameInInputBoxEdit({
                              division_name: item.Description,
                              transaction_id: item.TranId,
                            })
                          }
                          className="p-2 rounded-md hover:bg-gray-100 transition"
                        >
                          <EditIcon
                            fontSize="small"
                            className="text-gray-600"
                          />
                        </button>
                      </div>

                      {/* Edit Section */}
                      {isEditing && (
                        <div className="mt-4 flex flex-col sm:flex-row gap-3">
                          <input
                            type="text"
                            value={divisionNameInInputBoxEdit.division_name}
                            onChange={(e) =>
                              setDivisionNameInInputBoxEdit((prev) => ({
                                ...prev,
                                division_name: e.target.value,
                              }))
                            }
                            className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                          />

                          <div className="flex gap-2">
                            <button
                              type="button"
                              onClick={() =>
                                setDivisionNameInInputBoxEdit(
                                  initialDivisionInActionEdit,
                                )
                              }
                              className="flex items-center gap-1 px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                            >
                              <CancelIcon fontSize="small" />
                              Cancel
                            </button>

                            <button
                              type="button"
                              onClick={editDivisionAPI}
                              className="flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition"
                            >
                              <SaveIcon fontSize="small" />
                              Save
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {showJobTitleCreationEditPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            {/* Modal Card */}
            <div className="w-[95%] max-w-xl bg-white rounded-2xl shadow-2xl p-6 max-h-[60vh] overflow-y-auto scrollbar-none">
              {/* Header */}
              <div className="flex items-center justify-between border-b pb-3">
                <h2 className="text-lg font-semibold text-[#2663EB] flex items-center gap-2">
                  <BusinessIcon className="text-[#2663EB]" />
                  JOB TITLE MANAGEMENT
                </h2>

                <button
                  onClick={() => setShowJobTitleCreationEditPopup(false)}
                  className="p-2 rounded-full hover:bg-gray-100 transition"
                >
                  <CloseIcon />
                </button>
              </div>

              {/* Add New Job Title */}
              <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
                <input
                  value={jobTitleNameInInputBoxNew.jobTitle_name}
                  type="text"
                  placeholder="Enter new Job Title here..."
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                  onChange={(e) =>
                    setJobTitleNameInInputBoxNew((prev) => ({
                      ...prev,
                      jobTitle_name: e.target.value,
                    }))
                  }
                />

                <button
                  type="button"
                  onClick={newJobTitleAPI}
                  className="
    inline-flex items-center gap-2
    bg-blue-500
    text-white
    w-1/2
    px-2 py-1
    text-sm font-semibold
    rounded-md
    shadow-lg
    hover:from-blue-700 hover:to-blue-600
    active:scale-95
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
  "
                >
                  <Plus size={16} />
                  Add Job Title
                </button>
              </div>

              {/* JobTitle List */}
              <div className="mt-6 space-y-3">
                {jobTitleListFromAPI?.map((item) => {
                  const isEditing =
                    jobTitleNameInInputBoxEdit.transaction_id
                      ?.trim()
                      ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                  return (
                    <div
                      key={item.TranId}
                      className="border border-gray-200 rounded-xl px-2 py-1 hover:shadow-md transition"
                    >
                      {/* Row Header */}
                      <div className="flex items-center justify-between">
                        <span className="font-medium text-gray-700">
                          {item.Description}
                        </span>

                        <button
                          type="button"
                          onClick={() =>
                            setJobTitleNameInInputBoxEdit({
                              jobTitle_name: item.Description,
                              transaction_id: item.TranId,
                            })
                          }
                          className="p-2 rounded-md hover:bg-gray-100 transition"
                        >
                          <EditIcon
                            fontSize="small"
                            className="text-gray-600"
                          />
                        </button>
                      </div>

                      {/* Edit Section */}
                      {isEditing && (
                        <div className="mt-4 flex flex-col sm:flex-row gap-3">
                          <input
                            type="text"
                            value={jobTitleNameInInputBoxEdit.jobTitle_name}
                            onChange={(e) =>
                              setJobTitleNameInInputBoxEdit((prev) => ({
                                ...prev,
                                jobTitle_name: e.target.value,
                              }))
                            }
                            className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                          />

                          <div className="flex gap-2">
                            <button
                              type="button"
                              onClick={() =>
                                setJobTitleNameInInputBoxEdit(
                                  initialJobTitleInActionEdit,
                                )
                              }
                              className="flex items-center gap-1 px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                            >
                              <CancelIcon fontSize="small" />
                              Cancel
                            </button>

                            <button
                              type="button"
                              onClick={editJobTitleAPI}
                              className="flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition"
                            >
                              <SaveIcon fontSize="small" />
                              Save
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {showStatusCreationEditPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            {/* Modal Card */}
            <div className="w-[95%] max-w-xl bg-white rounded-2xl shadow-2xl p-6 max-h-[60vh] overflow-y-auto scrollbar-none">
              {/* Header */}
              <div className="flex items-center justify-between border-b pb-3">
                <h2 className="text-lg font-semibold text-[#2663EB] flex items-center gap-2">
                  <BusinessIcon className="text-[#2663EB]" />
                  STATUS MANAGEMENT
                </h2>

                <button
                  onClick={() => setShowStatusCreationEditPopup(false)}
                  className="p-2 rounded-full hover:bg-gray-100 transition"
                >
                  <CloseIcon />
                </button>
              </div>

              {/* Add New Status */}
              <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
                <input
                  value={statusNameInInputBoxNew.status_name}
                  type="text"
                  placeholder="Enter new Status here..."
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                  onChange={(e) =>
                    setStatusNameInInputBoxNew((prev) => ({
                      ...prev,
                      status_name: e.target.value,
                    }))
                  }
                />

                <button
                  type="button"
                  onClick={newStatusAPI}
                  className="
    inline-flex items-center gap-2
    bg-blue-500
    text-white
    w-1/2
    px-2 py-1
    text-sm font-semibold
    rounded-md
    shadow-lg
    hover:from-blue-700 hover:to-blue-600
    active:scale-95
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
  "
                >
                  <Plus size={16} />
                  Add Status
                </button>
              </div>

              {/* Status */}
              <div className="mt-6 space-y-3">
                {statusListFromAPI?.map((item) => {
                  const isEditing =
                    statusNameInInputBoxEdit.transaction_id
                      ?.trim()
                      ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                  return (
                    <div
                      key={item.TranId}
                      className="border border-gray-200 rounded-xl px-2 py-1 hover:shadow-md transition"
                    >
                      {/* Row Header */}
                      <div className="flex items-center justify-between">
                        <span className="font-medium text-gray-700">
                          {item.Description}
                        </span>

                        <button
                          type="button"
                          onClick={() =>
                            setStatusNameInInputBoxEdit({
                              status_name: item.Description,
                              transaction_id: item.TranId,
                            })
                          }
                          className="p-2 rounded-md hover:bg-gray-100 transition"
                        >
                          <EditIcon
                            fontSize="small"
                            className="text-gray-600"
                          />
                        </button>
                      </div>

                      {/* Edit Section */}
                      {isEditing && (
                        <div className="mt-4 flex flex-col sm:flex-row gap-3">
                          <input
                            type="text"
                            value={statusNameInInputBoxEdit.status_name}
                            onChange={(e) =>
                              setStatusNameInInputBoxEdit((prev) => ({
                                ...prev,
                                status_name: e.target.value,
                              }))
                            }
                            className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                          />

                          <div className="flex gap-2">
                            <button
                              type="button"
                              onClick={() =>
                                setStatusNameInInputBoxEdit(
                                  initialStatusInActionEdit,
                                )
                              }
                              className="flex items-center gap-1 px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                            >
                              <CancelIcon fontSize="small" />
                              Cancel
                            </button>

                            <button
                              type="button"
                              onClick={editStatusAPI}
                              className="flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition"
                            >
                              <SaveIcon fontSize="small" />
                              Save
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {/* Grade  */}

        {showGradeCreationEditPopup && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center pt-10 overflow-auto">
            <div className="bg-white w-11/12 max-w-md max-h-[90vh] rounded-lg shadow-lg overflow-y-auto p-6 flex flex-col">
              <div className="flex justify-between items-center mb-4 border-b pb-3">
                {/* <h5 className="text-lg font-semibold text-gray-900">Grade</h5> */}
                <h2 className="text-lg font-semibold text-[#2663EB] flex items-center gap-2">
                  <StarHalfIcon className="text-[#2663EB]" />
                  GRADE
                </h2>
                {/* <img
                  onClick={() => setShowGradeCreationEditPopup(false)}
                  src={ic_close_department}
                  alt="Close"
                  className="w-10 h-10 cursor-pointer object-contain"
                /> */}

                <FiX
                  onClick={() => setShowGradeCreationEditPopup(false)}
                  className="w-6 h-6 text-gray-700 hover:text-red-500 cursor-pointer"
                />
              </div>

              {/* Add New Grade */}
              <div className="flex items-center gap-3 mb-6">
                {/* <input
                        value={gradeNameInInputBoxNew.branch_name}
                        type="text"
                        placeholder="Enter grade name"
                        onChange={(e) =>
                          setGradeNameInInputBoxNew((prev) => ({
                            ...prev,
                            branch_name: e.target.value,
                          }))
                        }
                        className="flex-grow border-b border-gray-700 focus:outline-none focus:ring-1 focus:ring-blue-500 px-1 py-1"
                      /> */}

                <input
                  value={gradeNameInInputBoxNew.division_name}
                  type="text"
                  placeholder="Enter new grade name here..."
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                  onChange={(e) =>
                    setGradeNameInInputBoxNew((prev) => ({
                      ...prev,
                      branch_name: e.target.value,
                    }))
                  }
                />

                <button
                  type="button"
                  onClick={newGradeAPI}
                  className="
            inline-flex items-center gap-2
            bg-blue-500
            text-white
            w-1/2
            px-2 py-1
            text-sm font-semibold
            rounded-md
            shadow-lg
            hover:from-blue-700 hover:to-blue-600
            active:scale-95
            transition-all duration-200
            focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
          "
                >
                  <Plus size={16} />
                  Add Grade
                </button>
              </div>

              {/* Grade List */}
              <div className="space-y-3">
                {gradeListFromAPI?.map((item) => (
                  <div
                    key={item.TranId}
                    className="border border-gray-200 rounded"
                  >
                    <div
                      onClick={() =>
                        setGradeNameInInputBoxEdit({
                          branch_name: item.Description,
                          transaction_id: item.TranId,
                        })
                      }
                      className="flex justify-between items-center bg-transparent px-3 py-2 cursor-pointer hover:bg-gray-200 transition"
                    >
                      <span className="text-gray-900">{item.Description}</span>
                      <div className="flex gap-2">
                        <FiEdit2 className="text-blue-500 hover:text-blue-700 cursor-pointer w-5 h-5" />
                        <FiTrash2
                          onClick={() => deleteGradeAPI(item.TranId)}
                          className="text-red-500 hover:text-red-700 cursor-pointer w-5 h-5"
                        />
                      </div>
                    </div>

                    {gradeNameInInputBoxEdit.transaction_id === item.TranId && (
                      <div className="px-3 py-3 space-y-3">
                        <input
                          value={gradeNameInInputBoxEdit.branch_name}
                          onChange={(e) =>
                            setGradeNameInInputBoxEdit((prev) => ({
                              ...prev,
                              branch_name: e.target.value,
                            }))
                          }
                          className="w-full border-b border-gray-700 focus:outline-none focus:ring-1 focus:ring-blue-500 px-1 py-1"
                        />
                        <div className="flex gap-3">
                          <button
                            onClick={() =>
                              setGradeNameInInputBoxEdit(
                                initialGradeInActionEdit,
                              )
                            }
                            className="flex-1 border border-gray-300 rounded py-1 hover:bg-gray-100 transition"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => editGradeAPI()}
                            className="flex-1 bg-gray-800 text-white rounded py-1 hover:bg-gray-900 transition"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* {showDepartmentCreationEditPopup && (
          <div
            style={{
              width: "100vw",
              height: "100vh",
              position: "fixed",
              zIndex: "10",
              top: "0px",
              left: "0px",
              backgroundColor: "#00000080",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#ffffff",
                width: "80%",
                height: "90%",
                overflowY: "scroll",
                maxWidth: "600px",
                margin: "10px auto",
                padding: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <h5>Branch</h5>
                <img
                  onClick={() =>
                    setShowDepartmentCreationEditPopup((prev) => !prev)
                  }
                  className="ms-2"
                  style={{
                    width: "40px",
                    height: "40px",
                    objectFit: "contain",
                    cursor: "pointer",
                  }}
                  src={ic_close_department}
                />
              </div>

              <div className="mt-2">
                <input
                  value={branchNameInInputBoxNew.branch_name}
                  type="text"
                  style={{
                    border: "none",
                    borderBottom: "1px solid #000000",
                  }}
                  placeholder="enter branch name"
                  onChange={(e) =>
                    setBranchNameInInputBoxNew((prev) => ({
                      ...prev,
                      branch_name: e.target.value,
                    }))
                  }
                />

                <button
                  className="btn  btn-sm ms-2"
                  style={{ backgroundColor: "#32b0bd", color: "#ffffff" }}
                  onClick={() => newDepartmentAPI()}
                >
                  Add New Branch
                </button>
              </div>

              <div className="mt-2">
                {departmentLisFromAPI && (
                  <div>
                    {departmentLisFromAPI.map((item) => {
                      return (
                        <div style={{ border: "2px solid #f7f7f7" }}>
                          <div
                            onClick={(e) =>
                              setBranchNameInInputBoxEdit((prev) => ({
                                ...prev,
                                branch_name: item.Description,
                                transaction_id: item.TranId,
                              }))
                            }
                            style={{
                              backgroundColor: "#f7f7f7",
                              marginTop: "1px",
                            }}
                            className="px-2 py-1 d-flex"
                          >
                            <span>{item.Description}</span>
                            <img
                              className="ms-1"
                              style={{ width: "20px", height: "20px" }}
                              src={ic_pencil}
                            />
                          </div>

                          {branchNameInInputBoxEdit.transaction_id
                            ?.trim()
                            .toLocaleLowerCase() ==
                            item.TranId?.trim().toLocaleLowerCase() && (
                            <div className="mt-2 p-2">
                              <input
                                type="text"
                                style={{
                                  border: "none",
                                  borderBottom: "1px solid #000000",
                                }}
                                placeholder="enter branch name"
                                value={branchNameInInputBoxEdit.branch_name}
                                onChange={(e) =>
                                  setBranchNameInInputBoxEdit((prev) => ({
                                    ...prev,
                                    branch_name: e.target.value,
                                  }))
                                }
                              />
                              <button
                                className="btn btn-light btn-sm ms-2"
                                onClick={() =>
                                  setBranchNameInInputBoxEdit(
                                    initialBranchInActionEdit,
                                  )
                                }
                              >
                                Cancel
                              </button>
                              <button
                                className="btn btn-dark btn-sm ms-2"
                                onClick={() => editDepartmentAPI()}
                              >
                                Save
                              </button>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        )} */}
      </div>
      <div className="flex justify-center items-center">
        {/* <button
          type="submit"
          className="bg-teal-600 text-white w-[300px] px-4 py-2 rounded-md hover:bg-teal-700"
          disabled={showSubmitLoader}
        >
          {showSubmitLoader ? "Submitting..." : "Submit"}
        </button> */}
        <button
          type="submit"
          disabled={showSubmitLoader}
          className={`
            mb-12
    relative
    w-[300px]
    px-6 py-2.5
    rounded-xl
    font-semibold
    text-white
    transition-all duration-200
    shadow-md
    flex items-center justify-center gap-2
    ${
      showSubmitLoader
        ? "bg-green-400 cursor-not-allowed"
        : "bg-green-600 hover:bg-green-700 active:scale-95"
    }
  `}
        >
          {showSubmitLoader && (
            <svg
              className="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8H4z"
              ></path>
            </svg>
          )}

          {showSubmitLoader ? "Submitting..." : "Submit"}
        </button>
      </div>
      {/* {isSubmitted && (
        <p className="text-green-600">Form submitted successfully!</p>
      )} */}
    </form>
  );
};

export default PersonalInfo;
